<template>
  <section>
    <!-- exam dialog -->
    <div class="mx-8 mt-8 mb-5 px-8 py- bg-exam">
      <v-container>
        <v-row class="mb-5">
          <h3>
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.addEditExam'
              )
            }}
          </h3>
          <v-spacer />
          <div class="pt-4">
            <v-btn
              @click="tryExam"
              :loading="loadingTryExam"
              elevation="0"
              class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
            >
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.viewExam'
                )
              }}
            </v-btn>
          </div>
        </v-row>
        <v-row>
          <v-tabs class="tab-head" v-model="main_tabs" grow>
            <v-tab class="subtitle-1 tab-exam uppercast-unset" href="#detail">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.examDetail'
              )
            }}</v-tab>
            <v-tab
              v-if="typeOfExam == false"
              class="subtitle-1 tab-exam uppercast-unset"
              href="#question"
              :disabled="!examId"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.examQuestion'
                )
              }}</v-tab
            >
            <v-tabs-slider color="white"></v-tabs-slider>
            <v-tab
              v-if="typeOfExam == true"
              class="subtitle-1 tab-exam uppercast-unset"
              href="#question"
              :disabled="!examId || arrTagLevel.length == 0"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.examQuestion'
                )
              }}</v-tab
            >
          </v-tabs>
        </v-row>

        <v-row class="mt-3">
          <v-tabs-items v-model="main_tabs">
            <v-tab-item value="detail">
              <template>
                <v-form
                  ref="form"
                  v-model="valid"
                  v-on:submit.prevent="validate"
                >
                  <v-row>
                    <v-col xl="4" cols="6" :lg="6" :md="6" :sm="6">
                      <p class="subtitle-1 font-weight-bold">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.examName'
                          )
                        }}
                        <span class="red--text">*</span>
                      </p>
                      <v-text-field
                        outlined
                        v-model="title"
                        :rules="nameRules"
                        :placeholder="
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.pleaseFillName'
                          )
                        "
                        required
                        clearable
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="!examId">
                    <v-col class="text-right">
                      <v-btn
                        :disabled="title == ''"
                        elevation="0"
                        class="
                          px-10
                          ma-2
                          subtitle-2
                          text-capitalize
                          font-weight-light
                          button-primary
                        "
                        @click="validate()"
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.mssg22'
                          )
                        }}</v-btn
                      >
                    </v-col>
                  </v-row>
                  <div v-if="examId">
                    <v-row>
                      <v-col cols="12" :lg="12" :md="12" :sm="12">
                        <p class="subtitle-1 font-weight-bold">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.instruction'
                            )
                          }}
                        </p>
                        <quill-editor
                          class="editor mb-3"
                          ref="description"
                          v-model="description"
                          :value="description"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="row-radio-exam">
                        <p class="subtitle-1 font-weight-bold mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.setPercent'
                            )
                          }}
                        </p>
                        <v-row>
                          <v-col xl="7" cols="9">
                            <v-row>
                              <v-radio-group
                                v-model="setPercent"
                                mandatory
                                row
                                hide-details
                              >
                                <v-col xl="3" cols="4">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.no'
                                      )
                                    "
                                    :value="false"
                                  ></v-radio>
                                </v-col>
                                <v-col xl="3" cols="4">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.yes'
                                      )
                                    "
                                    :value="true"
                                  ></v-radio>
                                </v-col>
                              </v-radio-group>
                            </v-row>
                          </v-col>
                          <v-col
                            xl="5"
                            cols="3"
                            class="my-auto"
                            v-if="setPercent == true"
                          >
                            <v-row justify="end">
                              <v-col xl="3" cols="10">
                                <v-text-field
                                  outlined
                                  type="number"
                                  v-model.number="percentExam"
                                  maxlength="3"
                                  hide-details
                                  clearable
                                  prepend-inner-icon="mdi-greater-than-or-equal"
                                  min="0"
                                  max="100"
                                  @change="checkMinPercentExam"
                                ></v-text-field>
                              </v-col>
                              <v-col xl="1" cols="2">
                                <v-icon>mdi-percent</v-icon>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="row-radio-exam">
                        <p class="subtitle-1 font-weight-bold mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.timerOption'
                            )
                          }}
                        </p>
                        <v-row>
                          <v-col xl="7" cols="6">
                            <v-row>
                              <v-radio-group
                                v-model="time"
                                mandatory
                                row
                                hide-details
                              >
                                <v-col xl="3" cols="6">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.noTimer'
                                      )
                                    "
                                    :value="false"
                                  ></v-radio>
                                </v-col>
                                <v-col xl="3" cols="6">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.useTimer'
                                      )
                                    "
                                    :value="true"
                                  ></v-radio>
                                </v-col>
                              </v-radio-group>
                            </v-row>
                          </v-col>
                          <v-col xl="5" cols="6">
                            <v-row justify="end">
                              <v-col
                                xl="3"
                                cols="4"
                                class="my-auto"
                                v-if="time == true"
                              >
                                <v-text-field
                                  outlined
                                  v-model="mins"
                                  type="number"
                                  placeholder="0"
                                  min="0"
                                  hide-details
                                  @change="checkMinMins"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                xl="1"
                                cols="2"
                                class="my-auto"
                                v-if="time == true"
                              >
                                <p class="mb-0 py-3 text-left">
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.minute'
                                    )
                                  }}
                                </p>
                              </v-col>
                              <v-col
                                xl="3"
                                cols="4"
                                class="my-auto"
                                v-if="time == true"
                              >
                                <v-text-field
                                  outlined
                                  v-model="secs"
                                  placeholder="1"
                                  type="number"
                                  min="0"
                                  hide-details
                                  @change="checkMinSecs"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                xl="1"
                                cols="1"
                                class="my-auto"
                                v-if="time == true"
                              >
                                <p class="mb-0 py-3 text-left">
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.second'
                                    )
                                  }}
                                </p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="row-radio-exam">
                        <p class="subtitle-1 font-weight-bold mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.numExamTries'
                            )
                          }}
                        </p>
                        <v-row>
                          <v-col xl="7" cols="9">
                            <v-row>
                              <v-radio-group
                                v-model="repeat"
                                mandatory
                                row
                                hide-details
                              >
                                <v-col xl="3" cols="4">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.sigleTime'
                                      )
                                    "
                                    :value="1"
                                  ></v-radio>
                                </v-col>
                                <v-col xl="3" cols="4">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.unlimited'
                                      )
                                    "
                                    :value="0"
                                  ></v-radio>
                                </v-col>
                                <v-col xl="4" cols="4">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.multiTimes'
                                      )
                                    "
                                    :value="5"
                                  ></v-radio>
                                </v-col>
                              </v-radio-group>
                            </v-row>
                          </v-col>
                          <v-col xl="5" cols="3">
                            <v-row justify="end">
                              <v-col
                                xl="3"
                                cols="8"
                                class="my-auto"
                                v-if="repeat == 5"
                              >
                                <v-text-field
                                  outlined
                                  v-model="repeatTimes"
                                  placeholder="0"
                                  type="number"
                                  min="0"
                                  hide-details
                                ></v-text-field>
                              </v-col>
                              <v-col
                                xl="1"
                                cols="2"
                                class="my-auto"
                                v-if="repeat == 5"
                              >
                                <p class="mb-0 py-3 text-left">
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.times'
                                    )
                                  }}
                                </p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="row-radio-exam">
                        <p class="subtitle-1 font-weight-bold mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.questionSolving'
                            )
                          }}
                        </p>
                        <v-row>
                          <v-col xl="7" cols="9">
                            <v-row>
                              <v-radio-group
                                v-model="answer"
                                mandatory
                                row
                                hide-details
                              >
                                <v-col xl="3" cols="4">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.afterExam'
                                      )
                                    "
                                    :value="1"
                                  ></v-radio>
                                </v-col>
                                <v-col xl="3" cols="4">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.oneByOne'
                                      )
                                    "
                                    :value="2"
                                  ></v-radio>
                                </v-col>
                                <v-col xl="4" cols="4">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.noAnswer'
                                      )
                                    "
                                    :value="0"
                                  ></v-radio>
                                </v-col>
                              </v-radio-group>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" class="row-radio-exam">
                        <p class="subtitle-1 font-weight-bold mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.faceDetection'
                            )
                          }}
                        </p>
                        <v-row>
                          <v-col xl="7" cols="9">
                            <v-row>
                              <v-radio-group
                                v-model="faceDetection"
                                mandatory
                                row
                                hide-details
                                @change="checkFaceDetection()"
                              >
                                <v-col xl="3" cols="4">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.faceOptionNo'
                                      )
                                    "
                                    :value="false"
                                  ></v-radio>
                                </v-col>
                                <v-col xl="3" cols="4">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.faceOptionYes'
                                      )
                                    "
                                    :value="true"
                                  ></v-radio>
                                </v-col>
                              </v-radio-group>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row v-if="faceDetection == true">
                      <v-col cols="12" class="row-radio-exam">
                        <p class="subtitle-1 font-weight-bold mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.faceDetectionRandom'
                            )
                          }}
                        </p>
                        <v-row>
                          <v-col cols="6">
                            <v-row class="my-auto">
                              <v-radio-group
                                v-model="faceDetectionRandom"
                                mandatory
                                row
                                hide-details
                                @change="checkFaceDetection()"
                              >
                                <v-col xl="3" cols="6">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.faceRandomOptionNo'
                                      )
                                    "
                                    :value="false"
                                  ></v-radio>
                                </v-col>
                                <v-col xl="3" cols="6">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.faceRandomOptionYes'
                                      )
                                    "
                                    :value="true"
                                  ></v-radio>
                                </v-col>
                              </v-radio-group>
                            </v-row>
                          </v-col>
                          <v-col cols="6">
                            <v-row justify="end">
                              <v-col
                                cols="12"
                                class="row-radio-exam"
                                v-if="faceDetectionRandom == false"
                              >
                                <span class="caption">
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.faceChooseNumberOfQuestion'
                                    )
                                  }}
                                </span>
                                <v-combobox
                                  id="group"
                                  hide-details
                                  v-model="selectedNumberQuestion"
                                  :items="listCountQuestion"
                                  item-text="number"
                                  item-value="value"
                                  :placeholder="
                                    listCountQuestion.length > 0
                                      ? $vuetify.lang.t(
                                          '$vuetify.courseManagement.lectureStep.insertExam.faceMsg1'
                                        )
                                      : $vuetify.lang.t(
                                          '$vuetify.courseManagement.lectureStep.insertExam.faceMsg2'
                                        )
                                  "
                                  outlined
                                  dense
                                  multiple
                                  required
                                  small-chips
                                  background-color="white"
                                >
                                  <template
                                    v-slot:selection="{
                                      attrs,
                                      item,
                                      parent,
                                      selected,
                                    }"
                                  >
                                    <v-chip
                                      class="ma-1"
                                      v-if="item === Object(item)"
                                      v-bind="attrs"
                                      :input-value="selected"
                                      label
                                      small
                                    >
                                      <span class="pr-2">
                                        {{ item.number }}
                                      </span>
                                      <v-icon
                                        small
                                        @click="parent.selectItem(item)"
                                      >
                                        mdi-close-circle
                                      </v-icon>
                                    </v-chip>
                                  </template></v-combobox
                                >
                              </v-col>
                              <v-col
                                xl="3"
                                cols="6"
                                class="my-auto"
                                v-if="faceDetectionRandom == true"
                              >
                                <v-text-field
                                  outlined
                                  @change="checkLimit()"
                                  v-model="faceDetectionLimit"
                                  placeholder="0"
                                  type="number"
                                  min="0"
                                  :max="countNumberQuestion"
                                  hide-details
                                ></v-text-field>
                              </v-col>
                              <v-col
                                xl="1"
                                cols="2"
                                class="my-auto"
                                v-if="faceDetectionRandom == true"
                              >
                                <p class="mb-0 py-3 text-left">
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.times'
                                    )
                                  }}
                                </p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" class="row-radio-exam">
                        <p class="subtitle-1 font-weight-bold mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.typeExam'
                            )
                          }}
                          <span v-if="!examId" class="subtitle-1">{{
                            ' (' +
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.remarkTypeExam'
                            ) +
                            ') '
                          }}</span>
                        </p>
                        <v-row v-if="examId">
                          <v-col cols="12 my-3">
                            <v-radio-group
                              v-model="typeOfExam"
                              mandatory
                              row
                              hide-details
                            >
                              <v-radio
                                v-if="chooseRandomQuestion == false"
                                :label="
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.typeExamGeneral'
                                  )
                                "
                                :value="false"
                              ></v-radio>
                              <v-radio
                                v-if="chooseRandomQuestion == true"
                                :label="
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.typeExamCustomizable'
                                  )
                                "
                                :value="true"
                              ></v-radio>
                            </v-radio-group>
                          </v-col>
                        </v-row>
                        <v-row v-if="!examId">
                          <v-col cols="12" class="my-3">
                            <v-radio-group
                              v-model="typeOfExam"
                              mandatory
                              row
                              hide-details
                            >
                              <v-radio
                                :label="
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.typeExamGeneral'
                                  )
                                "
                                :value="false"
                              ></v-radio>
                              <v-radio
                                :label="
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.typeExamCustomizable'
                                  )
                                "
                                :value="true"
                              ></v-radio>
                            </v-radio-group>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="pt-0" v-if="typeOfExam == true">
                        <v-alert
                          text
                          dense
                          type="info"
                          border="left"
                          class="mb-0"
                        >
                          <strong class="font-weight-bold">{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.instructionQuestion'
                            )
                          }}</strong>
                          <br />
                          <strong class="font-weight-regular">
                            <label class="headExplan">"</label
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.mssg20'
                              )
                            }}<label class="headExplan">"</label>
                          </strong>
                          <br />
                          <span class="font-weight-light">
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.mssg21'
                              )
                            }}
                          </span>
                        </v-alert>
                      </v-col>
                    </v-row>

                    <v-row v-if="typeOfExam == false">
                      <v-col cols="12" class="row-radio-exam">
                        <p class="subtitle-1 font-weight-bold mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.randomQuestions'
                            )
                          }}
                        </p>
                        <v-row>
                          <v-col xl="7" cols="9">
                            <v-row>
                              <v-radio-group
                                v-model="randomQuestion"
                                mandatory
                                row
                                hide-details
                              >
                                <v-col xl="3" cols="4">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.noRandom'
                                      )
                                    "
                                    :value="false"
                                  ></v-radio>
                                </v-col>
                                <v-col xl="3" cols="4">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.random'
                                      )
                                    "
                                    :value="true"
                                  ></v-radio>
                                </v-col>
                              </v-radio-group>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row v-if="randomQuestion == true">
                          <v-col cols="12" class="row-radio-exam">
                            <p class="subtitle-1 font-weight-bold mb-0">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.conditionRandom'
                                )
                              }}
                            </p>
                            <v-row>
                              <v-col xl="7" cols="9">
                                <v-row>
                                  <v-radio-group
                                    v-model="conditionalRandom"
                                    mandatory
                                    row
                                    hide-details
                                  >
                                    <v-col xl="3" cols="4">
                                      <v-radio
                                        :label="
                                          $vuetify.lang.t(
                                            '$vuetify.courseManagement.lectureStep.insertExam.conditionRandomFirst'
                                          )
                                        "
                                        :value="true"
                                      ></v-radio>
                                    </v-col>
                                    <v-col xl="3" cols="4">
                                      <v-radio
                                        :label="
                                          $vuetify.lang.t(
                                            '$vuetify.courseManagement.lectureStep.insertExam.conditionRandomAlways'
                                          )
                                        "
                                        :value="false"
                                      ></v-radio>
                                    </v-col>
                                  </v-radio-group>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row v-if="typeOfExam == false">
                      <v-col cols="12" class="row-radio-exam">
                        <p class="subtitle-1 font-weight-bold mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.randomChoices'
                            )
                          }}
                        </p>
                        <v-row>
                          <v-col xl="7" cols="9">
                            <v-row>
                              <v-radio-group
                                v-model="randomChoices"
                                mandatory
                                row
                                hide-details=""
                              >
                                <v-col xl="3" cols="4">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.noRandom2'
                                      )
                                    "
                                    :value="false"
                                  ></v-radio>
                                </v-col>
                                <v-col xl="3" cols="4">
                                  <v-radio
                                    :label="
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.random2'
                                      )
                                    "
                                    :value="true"
                                  ></v-radio>
                                </v-col>
                              </v-radio-group>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row v-if="typeOfExam == true">
                      <v-col cols="12" class="ma-0 pa-0 row-radio-exam">
                        <v-card
                          class="px-5"
                          elevation="0"
                          color="grey lighten-5"
                        >
                          <v-row>
                            <v-col cols="12">
                              <p class="subtitle-1 font-weight-bold mb-0">
                                {{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.conditionRandom'
                                  )
                                }}
                              </p>
                              <v-row>
                                <v-col xl="5" cols="9">
                                  <v-row>
                                    <v-radio-group
                                      v-model="conditionalRandom"
                                      mandatory
                                      row
                                      hide-details
                                    >
                                      <v-col xl="4" cols="4">
                                        <v-radio
                                          :label="
                                            $vuetify.lang.t(
                                              '$vuetify.courseManagement.lectureStep.insertExam.conditionRandomFirst'
                                            )
                                          "
                                          :value="true"
                                        ></v-radio>
                                      </v-col>
                                      <v-col xl="4" cols="4">
                                        <v-radio
                                          :label="
                                            $vuetify.lang.t(
                                              '$vuetify.courseManagement.lectureStep.insertExam.conditionRandomAlways'
                                            )
                                          "
                                          :value="false"
                                        ></v-radio>
                                      </v-col>
                                    </v-radio-group>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" class="row-radio-exam">
                              <p class="subtitle-1 font-weight-bold mb-0">
                                {{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.randomChoices'
                                  )
                                }}
                              </p>
                              <v-row>
                                <v-col xl="7" cols="9">
                                  <v-row>
                                    <v-radio-group
                                      v-model="randomChoices"
                                      mandatory
                                      row
                                      hide-details
                                    >
                                      <v-col xl="3" cols="4">
                                        <v-radio
                                          :label="
                                            $vuetify.lang.t(
                                              '$vuetify.courseManagement.lectureStep.insertExam.noRandom2'
                                            )
                                          "
                                          :value="false"
                                        ></v-radio>
                                      </v-col>
                                      <v-col xl="3" cols="4">
                                        <v-radio
                                          :label="
                                            $vuetify.lang.t(
                                              '$vuetify.courseManagement.lectureStep.insertExam.random2'
                                            )
                                          "
                                          :value="true"
                                        ></v-radio>
                                      </v-col>
                                    </v-radio-group>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <p class="subtitle-1 font-weight-bold mb-0">
                                {{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.GroupAssignmentOfQuestions'
                                  )
                                }}
                              </p>
                            </v-col>
                          </v-row>

                          <div v-if="typeOfExam == true">
                            <v-row class="mr-1">
                              <v-col cols="6" v-if="arrTagLevel.length > 0">
                                <span class="body-1 font-weight-light"
                                  >{{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.totalScoreOfExam'
                                    )
                                  }}
                                  :
                                  {{
                                    totalScore +
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.totalScore'
                                    )
                                  }}
                                </span>
                              </v-col>
                              <v-col
                                :cols="arrTagLevel.length > 0 ? '6' : '12'"
                                :class="
                                  arrTagLevel.length > 0
                                    ? 'text-right'
                                    : 'text-center'
                                "
                              >
                                <v-btn
                                  elevation="0"
                                  class="
                                    pl-5
                                    pr-5
                                    mb-0
                                    body-2
                                    button-primary
                                    text-capitalize
                                  "
                                  @click="openTagLevel"
                                  :disabled="loadingbtn"
                                >
                                  <v-icon left>mdi-plus</v-icon>
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.addQuestionGroup'
                                    )
                                  }}
                                </v-btn>
                              </v-col>
                            </v-row>

                            <!-- dialog add question group -->
                            <v-dialog
                              v-model="questionGroupDialog"
                              max-width="500"
                            >
                              <v-card>
                                <v-card-title>
                                  <h4 class="font-weight-medium pl-3">
                                    {{
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.tableHeadersQuestionGroup.titleDialogAdd'
                                      )
                                    }}
                                  </h4>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    icon
                                    light
                                    @click="questionGroupDialog = false"
                                    :disabled="loadingSaveTagLevel"
                                  >
                                    <v-icon>mdi-close</v-icon>
                                  </v-btn>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="pl-7 pr-5">
                                  <v-form>
                                    <v-container>
                                      <v-row>
                                        <v-col cols="12">
                                          <span
                                            class="body-2 font-weight-black"
                                            >{{
                                              $vuetify.lang.t(
                                                '$vuetify.courseManagement.lectureStep.insertExam.nameGroup'
                                              )
                                            }}</span
                                          >
                                          <v-text-field
                                            v-model="itemTaglevel.text"
                                            class="mt-1"
                                            outlined
                                            clearable
                                            hide-details
                                          ></v-text-field>
                                        </v-col>
                                      </v-row>
                                      <v-row>
                                        <v-col cols="12">
                                          <span
                                            class="body-2 font-weight-black"
                                            >{{
                                              $vuetify.lang.t(
                                                '$vuetify.courseManagement.lectureStep.insertExam.numberOfQuestion'
                                              )
                                            }}</span
                                          >
                                          <v-text-field
                                            v-model="
                                              itemTaglevel.numberOfQuestion
                                            "
                                            class="mt-1"
                                            outlined
                                            clearable
                                            hide-details
                                            placeholder="0"
                                            type="number"
                                            min="0"
                                          ></v-text-field>
                                        </v-col>
                                      </v-row>
                                      <v-row>
                                        <v-col cols="12">
                                          <span
                                            class="body-2 font-weight-black"
                                            >{{
                                              $vuetify.lang.t(
                                                '$vuetify.courseManagement.lectureStep.insertExam.scorePerOne'
                                              )
                                            }}</span
                                          >
                                          <v-text-field
                                            v-model="itemTaglevel.score"
                                            placeholder="0"
                                            type="number"
                                            min="0"
                                            class="mt-1"
                                            outlined
                                            clearable
                                            hide-details
                                          ></v-text-field>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-form>
                                </v-card-text>
                                <v-card-actions class="pb-6 pr-8">
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    outlined
                                    class="
                                      font-weight-regular
                                      button-secondary
                                      mx-1
                                      text-capitalize
                                    "
                                    width="90"
                                    @click="questionGroupDialog = false"
                                    :disabled="loadingSaveTagLevel"
                                  >
                                    {{
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.courseList.cancel'
                                      )
                                    }}
                                  </v-btn>
                                  <v-btn
                                    color="rgb(66, 154, 216)"
                                    class="
                                      font-weight-regular
                                      button
                                      mx-1
                                      text-capitalize
                                      white--text
                                    "
                                    width="90"
                                    :loading="loadingSaveTagLevel"
                                    @click="saveTagLevel"
                                    :disabled="
                                      !itemTaglevel.text ||
                                      itemTaglevel.score == 0 ||
                                      itemTaglevel.numberOfQuestion == 0 ||
                                      loadingbtn
                                    "
                                  >
                                    {{
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.courseList.save'
                                      )
                                    }}
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                            <!-- end dialog add question group -->

                            <!-- data table -->
                            <v-data-table
                              v-if="arrTagLevel.length > 0"
                              :headers="tableHeadersQuestionGroup"
                              :items="arrTagLevel"
                              class="elevation-1"
                              hide-default-footer
                              :page.sync="pageLevel"
                              items-per-page="5"
                            >
                              <template
                                v-slot:item.questionGroupName="{ item }"
                              >
                                <span>{{ item.text }}</span>
                              </template>

                              <template v-slot:item.randomNumber="{ item }">
                                <span
                                  >{{
                                    item.numberOfQuestion +
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.ofQuestion'
                                    )
                                  }}
                                </span>
                              </template>

                              <template v-slot:item.totalNumber="{ item }">
                                <span>{{
                                  item.countQuestion +
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.ofQuestion'
                                  )
                                }}</span>
                              </template>

                              <template v-slot:item.score="{ item }">
                                <span>{{
                                  item.score +
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.pointPerQuestion'
                                  )
                                }}</span>
                              </template>

                              <template v-slot:item.totalScore="{ item }">
                                <span>{{
                                  item.sumScore +
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.totalScore'
                                  )
                                }}</span>
                              </template>

                              <template v-slot:item.action="{ item }">
                                <v-btn
                                  class="
                                    ma-2
                                    body-2
                                    primary--text
                                    text-capitalize
                                  "
                                  color="white"
                                  :disabled="loadingbtn"
                                  @click="
                                    editTagLevel(
                                      item,
                                      arrTagLevel.indexOf(item)
                                    )
                                  "
                                  depressed
                                >
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.courseList.edit'
                                    )
                                  }}
                                </v-btn>
                                <v-divider
                                  vertical
                                  class="divider-data-table"
                                ></v-divider>
                                <v-btn
                                  class="
                                    ma-2
                                    body-2
                                    error--text
                                    text-capitalize
                                  "
                                  color="white"
                                  @click="confirmDeleteTagLevel(item.id)"
                                  depressed
                                  :disabled="
                                    bools == true ||
                                    item.countQuestion > 0 ||
                                    loadingbtn
                                  "
                                >
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.courseList.delete'
                                    )
                                  }}
                                </v-btn>
                              </template>
                            </v-data-table>
                            <v-row v-if="arrTagLevel.length > 0">
                              <v-col cols="12">
                                <v-pagination
                                  v-model="pageLevel"
                                  :length="pageLevelLength"
                                  @input="changePageLevel"
                                  color="rgb(66, 154, 216)"
                                  :total-visible="10"
                                ></v-pagination>
                              </v-col>
                            </v-row>
                            <!-- end data table -->
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col xl="9" cols="6" class="pb-0">
                        <p class="subtitle-1 font-weight-bold mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.publishedTimeDate'
                            )
                          }}
                        </p>

                        <v-row>
                          <v-col xl="4" cols="11" class="pb-1">
                            <v-row>
                              <v-col cols="2" class="pt-2">
                                <v-switch
                                  inset
                                  v-model="isModifyStartEndTime"
                                  class="pr-3"
                                  color="primary"
                                  hide-details
                                ></v-switch>
                              </v-col>
                              <v-col cols="10" class="pt-2">
                                <span
                                  v-if="!isModifyStartEndTime"
                                  class="subtitle-1 font-weight-light"
                                  >{{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.noPublishedTimeDate'
                                    )
                                  }}</span
                                >
                                <span
                                  v-else
                                  class="
                                    primary--text
                                    subtitle-1
                                    font-weight-light
                                  "
                                  >{{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.setPublishedTimeDate'
                                    )
                                  }}</span
                                >
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col sm="12" md="9" xl="5" cols="12" class="py-0">
                        <v-row>
                          <v-col cols="12" sm="5" md="5" xl="5">
                            <div
                              class="set-date-exam-start"
                              v-if="isModifyStartEndTime"
                            >
                              <div
                                :disabled="!isModifyStartEndTime"
                                class="
                                  datetime
                                  d-flex
                                  align-center
                                  justify-between
                                  mb-5
                                "
                              >
                                <span
                                  :disabled="!isModifyStartEndTime"
                                  class="subtitle-1 font-weight-light"
                                  >{{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.start'
                                    )
                                  }}:</span
                                >
                                <datetime
                                  ref="search_start_date"
                                  :disabled="!isModifyStartEndTime"
                                  type="datetime"
                                  input-id="startDate"
                                  rules="startTimeRule"
                                  v-model="startTime"
                                  format="dd/MM/yyyy HH:mm:ss"
                                  placeholder="วัน-เวลา เริ่ม"
                                  class="
                                    subtitle-1
                                    font-weight-light
                                    ml-3
                                    exam-date
                                  "
                                ></datetime>
                                <v-icon
                                  class="icon-calendar"
                                  @click="
                                    open_calender($event, 'search_start_date')
                                  "
                                  >mdi-calendar-text</v-icon
                                >
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" sm="6" xl="6">
                            <div
                              class="set-date-exam-end"
                              v-if="isModifyStartEndTime"
                            >
                              <div
                                class="
                                  datetime
                                  d-flex
                                  align-center
                                  justify-between
                                "
                              >
                                <span
                                  :disabled="!isModifyStartEndTime"
                                  class="subtitle-1 font-weight-light"
                                  >{{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.end'
                                    )
                                  }}:</span
                                >
                                <datetime
                                  ref="search_end_date"
                                  :disabled="!isModifyStartEndTime"
                                  type="datetime"
                                  rules="endDateRule"
                                  input-id="endDate"
                                  v-model="endTime"
                                  format="dd/MM/yyyy HH:mm:ss"
                                  placeholder="วัน-เวลา สิ้นสุด"
                                  class="
                                    subtitle-1
                                    font-weight-light
                                    ml-3
                                    exam-date
                                  "
                                >
                                </datetime>
                                <v-icon
                                  class="icon-calendar"
                                  @click="
                                    open_calender($event, 'search_end_date')
                                  "
                                  >mdi-calendar-text</v-icon
                                >
                              </div>
                              <div class="mt-5" v-if="endTime <= startTime">
                                <span class="red--text"
                                  >*{{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.scheduleInstruction'
                                    )
                                  }}</span
                                >
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        elevation="0"
                        class="
                          px-5
                          ma-2
                          subtitle-2
                          button-secondary
                          font-weight-light
                        "
                        outlined
                        @click="checkToSave"
                        :disabled="loadingbtn"
                      >
                        <v-icon left>mdi-arrow-left</v-icon>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.btnBackLecture'
                          )
                        }}</v-btn
                      >
                      <v-btn
                        elevation="0"
                        class="
                          px-10
                          ma-2
                          subtitle-2
                          text-capitalize
                          font-weight-light
                          button-primary
                        "
                        @click="validate"
                        :loading="loadingbtn"
                        :disabled="
                          !valid ||
                          (endTime < startTime && endTime != startTime) ||
                          (settingLevel == true &&
                            this.arrTagLevel.length == 0) ||
                          bools == true ||
                          loadingbtn ||
                          (faceDetection == true &&
                            faceDetectionRandom == false &&
                            selectedNumberQuestion.length == 0) ||
                          (faceDetection == true &&
                            faceDetectionRandom == true &&
                            faceDetectionLimit == 0)
                        "
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.save'
                          )
                        }}</v-btn
                      >
                    </v-card-actions>
                  </div>
                </v-form>
              </template>
            </v-tab-item>
            <v-tab-item value="question">
              <div v-if="examId">
                <div text class="mb-2 pa-5">
                  <strong class="font-weight-bold">
                    <label
                      >"{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.msg1'
                        )
                      }}"</label
                    >
                  </strong>
                  <br />
                  <p>
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.msg2'
                      ) +
                      ' ' +
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.msg3'
                      ) +
                      ' ' +
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.msg4'
                      ) +
                      ' ' +
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.msg5'
                      )
                    }}
                  </p>
                  <strong class="font-weight-bold">
                    <label
                      >"{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.msg7'
                        )
                      }}"</label
                    >
                  </strong>
                  <br />

                  <p>
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.msg8'
                      ) +
                      ' ' +
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.msg9'
                      ) +
                      ' ' +
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.msg10'
                      ) +
                      ' ' +
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.msg11'
                      ) +
                      ' ' +
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.msg12'
                      ) +
                      ' ' +
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.msg13'
                      )
                    }}
                  </p>

                  <strong class="font-weight-bold">{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.msg15'
                    )
                  }}</strong>
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.msg16'
                    )
                  }}
                  <br />{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.msg17'
                    )
                  }}
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.msg18'
                    )
                  }}
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.msg19'
                    )
                  }}
                </div>
                <v-card-actions class="py-0 ml-5 mr-2">
                  <v-spacer></v-spacer>
                  <v-btn
                    v-show="pageCount != 0 && questions.length >= 2"
                    elevation="0"
                    @click="modifyExam()"
                    class="
                      pl-5
                      pr-5
                      mr-5
                      xs-full-width
                      font-weight-light
                      body-2
                      button-secondary
                      text-capitalize
                    "
                  >
                    <v-icon left>mdi-playlist-edit</v-icon
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.modifyExam'
                      )
                    }}
                  </v-btn>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        elevation="0"
                        class="
                          pl-5
                          pr-5
                          mr-5
                          xs-full-width
                          font-weight-light
                          body-2
                          button-secondary
                          text-capitalize
                        "
                      >
                        <v-icon left>mdi-microsoft-excel</v-icon
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.importExam'
                          )
                        }}
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="openDialogImport('single')">
                        <v-list-item-icon class="mr-2">
                          <v-icon small>mdi-check-box-outline</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title
                            class="font-weight-light subtitle-2"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.singleChoice'
                              )
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item @click="openDialogImport('multiple')">
                        <v-list-item-icon class="mr-2">
                          <v-icon small>mdi-check-box-multiple-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            class="font-weight-light subtitle-2"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.multipleChoices'
                              )
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        elevation="0"
                        class="
                          pl-5
                          pr-5
                          xs-full-width
                          font-weight-light
                          button-primary
                          white--text
                          text-capitalize
                        "
                      >
                        <v-icon left>mdi-plus</v-icon
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.newQuestion'
                          )
                        }}
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="editQuestion(null, 'single', null)">
                        <v-list-item-icon class="mr-2">
                          <v-icon small>mdi-check-box-outline</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title
                            class="font-weight-light subtitle-2"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.singleChoice'
                              )
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item
                        @click="editQuestion(null, 'multiple', null)"
                      >
                        <v-list-item-icon class="mr-2">
                          <v-icon small>mdi-check-box-multiple-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            class="font-weight-light subtitle-2"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.multipleChoices'
                              )
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item
                        @click="editQuestion(null, 'matchsome', null)"
                        v-if="typeOfExam == false"
                      >
                        <v-list-item-icon class="mr-2">
                          <v-icon small>mdi-shuffle</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title
                            class="font-weight-light subtitle-2"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.matching'
                              )
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider v-if="typeOfExam == false"></v-divider>
                      <v-list-item
                        @click="editQuestion(null, 'fillgaptext', null)"
                      >
                        <v-list-item-icon class="mr-2">
                          <v-icon small>mdi-color-helper</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title
                            class="font-weight-light subtitle-2"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.fillBlank'
                              )
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider v-if="typeOfExam == false"></v-divider>
                      <v-list-item
                        @click="editQuestion(null, 'article', null)"
                        v-if="typeOfExam == false"
                      >
                        <v-list-item-icon class="mr-2">
                          <v-icon small>mdi-format-float-left</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title
                            class="font-weight-light subtitle-2"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.article'
                              )
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider v-if="typeOfExam == false"></v-divider>
                      <v-list-item
                        @click="editQuestion(null, 'game', null)"
                        v-if="typeOfExam == false"
                      >
                        <v-list-item-icon class="mr-2">
                          <v-icon small>mdi-puzzle</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title
                            class="font-weight-light subtitle-2"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.game'
                              )
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-btn
                    v-show="questions.length > 0"
                    elevation="0"
                    min-width="20"
                    class="ml-5 font-weight-light body-2 button-secondary"
                    @click="confirmMultiDelete()"
                    :disabled="selected_exam.length < 1"
                  >
                    <v-icon left class="pl-1">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-card-actions>
                <span v-if="typeOfExam == true" class="caption mx-3">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.questionGroupFilter'
                    )
                  }}
                </span>
                <v-autocomplete
                  v-if="typeOfExam == true"
                  v-model="selectTagLevel"
                  :items="arrTagLevelFilter"
                  item-text="text"
                  class="mx-3 my-3"
                  item-value="id"
                  @change="getListQuestionByTagLevel(selectTagLevel)"
                  outlined
                  hide-details
                  :placeholder="
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.chooseQuestionGroup'
                    )
                  "
                  background-color="white"
                ></v-autocomplete>
                <!-- question list -->
                <v-card-actions class="py-0 ml-5 mr-2">
                  <span class="" v-show="questions.length > 0">
                    <v-checkbox
                      class="my-2"
                      hide-details
                      v-model="allSelected"
                      @change="selectAll"
                    ></v-checkbox>
                  </span>
                  <div class="ml-2" v-show="questions.length > 0">
                    <!-- <label class="font-weight-bold">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.tableHeadersQuestionList.questionList'
                      )
                    }}
                  </label> -->
                    <span class="text-body-1 font-weight-bold mb-0">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.tableHeadersQuestionList.totalQuestion'
                        )
                      }}
                      : {{ questions.length }}
                    </span>
                  </div>
                </v-card-actions>
                <div
                  class="mx-3"
                  v-for="(question, index) in questions"
                  :key="question.id"
                >
                  <v-card
                    v-if="question.typeQuestion != 'article'"
                    outlined
                    elevation="0"
                    class="mt-5 bg-card"
                    width="100%"
                  >
                    <v-list-item>
                      <v-list-item-icon class="my-0 mr-2 py-2">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-checkbox
                              v-on="on"
                              v-model="selected_exam"
                              @change="select"
                              :value="question._id"
                            ></v-checkbox>
                          </template>
                          <span class="subtitle-1">{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.selectToDelete'
                            )
                          }}</span>
                        </v-tooltip>
                      </v-list-item-icon>
                      <v-list-item-content class="py-2">
                        <v-list-item-title class="ma-0">
                          <span class="body-1 my-auto font-weight-light mr-2">{{
                            limit * (page - 1) +
                            (index + 1) +
                            '. ' +
                            question.question
                          }}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-icon-grey">
                          <!-- <v-icon>{{ question.icon }}</v-icon> -->
                          <span class="font-weight-bold"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.type'
                              )
                            }}: </span
                          >{{ question.name }}

                          <span
                            class="font-weight-bold ml-3"
                            v-if="question.tag"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.groupQuestion'
                              )
                            }}: </span
                          >{{ question.tag }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-row align="center" justify="end">
                          <v-btn
                            elevation="0"
                            class="mb-0 body-2 text-primary text-capitalize"
                            color="white"
                            @click="
                              editQuestion(
                                question._id,
                                question.typeQuestion,
                                null
                              )
                            "
                          >
                            <p class="mb-0">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.courseList.edit'
                                )
                              }}
                            </p>
                          </v-btn>
                          <v-divider
                            inset
                            vertical
                            class="mb-2 mx-1"
                          ></v-divider>
                          <v-btn
                            elevation="0"
                            class="mb-0 body-2 error--text text-capitalize"
                            color="white"
                            @click="confirmDelete(question._id)"
                          >
                            <p class="mb-0">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.courseList.delete'
                                )
                              }}
                            </p>
                          </v-btn>
                        </v-row>
                      </v-list-item-action>
                    </v-list-item>
                  </v-card>

                  <v-card
                    v-if="question.typeQuestion == 'article'"
                    outlined
                    elevation="0"
                    class="mt-5 card-custom"
                    width="100%"
                  >
                    <v-list-item>
                      <v-list-item-icon class="my-0 mr-2">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-checkbox
                              v-on="on"
                              v-model="selected_exam"
                              @change="select"
                              :value="question._id"
                            ></v-checkbox>
                          </template>
                          <span class="subtitle-1">{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.selectToDelete'
                            )
                          }}</span>
                        </v-tooltip>
                      </v-list-item-icon>
                      <v-list-item-content class="py-2">
                        <v-list-item-title class="ma-0">
                          <span class="body-1 my-auto font-weight-light mr-2">{{
                            limit * (page - 1) +
                            (index + 1) +
                            '. ' +
                            question.question
                          }}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <!-- <v-icon>{{ question.icon }}</v-icon> -->
                          {{ question.name }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            @click="openExpand(index, 'list')"
                            icon
                            class="md-position-absolute centerx-ele mt-2 active"
                            :id="`centerx-ele-list-${index}`"
                          >
                            <v-icon class="icon">mdi-chevron-down</v-icon>
                          </v-btn>
                        </template>
                        <span class="subtitle-1">{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.clickToHideOrShow'
                          )
                        }}</span>
                      </v-tooltip>
                      <v-list-item-action>
                        <v-row align="center" justify="end">
                          <v-btn
                            elevation="0"
                            class="mb-0 body-2 text-primary text-capitalize"
                            color="white"
                            @click="
                              editQuestion(
                                question._id,
                                question.typeQuestion,
                                null
                              )
                            "
                          >
                            <p class="mb-0">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.courseList.edit'
                                )
                              }}
                            </p>
                          </v-btn>
                          <v-divider
                            inset
                            vertical
                            class="mb-2 mx-1"
                          ></v-divider>
                          <v-btn
                            elevation="0"
                            class="mb-0 body-2 error--text text-capitalize"
                            color="white"
                            @click="confirmDelete(question._id)"
                          >
                            <p class="mb-0">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.delete'
                                )
                              }}
                            </p>
                          </v-btn>
                        </v-row>
                      </v-list-item-action>
                    </v-list-item>
                  </v-card>

                  <div
                    v-if="question.typeQuestion == 'article'"
                    :id="`expand-list-${index}`"
                  >
                    <v-card outlined elevation="0" class="mt-0 card-child">
                      <p
                        class="subtitle-1 text-center blue-grey--text mt-0"
                        v-if="question.children.length == 0"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.noQuestion'
                          )
                        }}
                      </p>
                      <v-divider
                        v-if="question.children.length == 0"
                        class="ma-0"
                      ></v-divider>
                      <div
                        v-for="(child, indexChild) in question.children"
                        :key="child._id"
                      >
                        <v-list-item>
                          <v-list-item-icon class="my-0 mr-4">
                          </v-list-item-icon>
                          <v-list-item-content class="py-2">
                            <v-list-item-title class="ma-0">
                              <span
                                class="body-1 my-auto font-weight-light mr-2"
                              >
                                {{
                                  limit * (page - 1) +
                                  (index + 1) +
                                  '.' +
                                  (indexChild + 1) +
                                  '. ' +
                                  child.question
                                }}
                              </span>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <!-- <v-icon>{{ child.icon }}</v-icon> -->
                              {{ child.name }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-row align="center" justify="end">
                              <v-btn
                                elevation="0"
                                class="mb-0 body-2 text-primary text-capitalize"
                                color="white"
                                @click="
                                  editQuestion(
                                    child._id,
                                    child.typeQuestion,
                                    child.articleQuestion
                                  )
                                "
                              >
                                <p class="mb-0">
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.courseList.edit'
                                    )
                                  }}
                                </p>
                              </v-btn>

                              <v-divider
                                inset
                                vertical
                                class="mb-2 mx-1"
                              ></v-divider>

                              <v-btn
                                elevation="0"
                                class="mb-0 body-2 error--text text-capitalize"
                                color="white"
                                @click="confirmDelete(child._id)"
                              >
                                <p class="mb-0">
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.courseList.delete'
                                    )
                                  }}
                                </p>
                              </v-btn>
                            </v-row>
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider class="ma-0"></v-divider>
                      </div>
                      <v-row justify="center">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              large
                              elevation="0"
                              class="
                                my-3
                                subtitle-1
                                text-primary text-capitalize
                                font-weight-bold
                              "
                              color="white"
                              v-on="on"
                            >
                              <v-icon left>mdi-plus</v-icon
                              >{{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.newQuestion'
                                )
                              }}
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              @click="
                                editQuestion(null, 'single', question._id)
                              "
                            >
                              <v-list-item-icon class="mr-2">
                                <v-icon small>mdi-check-box-outline</v-icon>
                              </v-list-item-icon>

                              <v-list-item-content>
                                <v-list-item-title
                                  class="font-weight-light subtitle-2"
                                  >{{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.singleChoice'
                                    )
                                  }}</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item
                              @click="
                                editQuestion(null, 'multiple', question._id)
                              "
                            >
                              <v-list-item-icon class="mr-2">
                                <v-icon small
                                  >mdi-check-box-multiple-outline</v-icon
                                >
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title
                                  class="font-weight-light subtitle-2"
                                  >{{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.multipleChoices'
                                    )
                                  }}</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item
                              @click="
                                editQuestion(null, 'matchsome', question._id)
                              "
                            >
                              <v-list-item-icon class="mr-2">
                                <v-icon small>mdi-shuffle</v-icon>
                              </v-list-item-icon>

                              <v-list-item-content>
                                <v-list-item-title
                                  class="font-weight-light subtitle-2"
                                  >{{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.matching'
                                    )
                                  }}</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item
                              @click="
                                editQuestion(null, 'fillgaptext', question._id)
                              "
                            >
                              <v-list-item-icon class="mr-2">
                                <v-icon small>mdi-color-helper</v-icon>
                              </v-list-item-icon>

                              <v-list-item-content>
                                <v-list-item-title
                                  class="font-weight-light subtitle-2"
                                  >{{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.fillBlank'
                                    )
                                  }}</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-row>
                    </v-card>
                  </div>
                </div>

                <v-card-actions v-if="questions.length > 0">
                  <v-row justify="end">
                    <v-pagination
                      v-model="page"
                      :length="pageCount"
                      @input="changePage"
                      color="rgb(66, 154, 216)"
                      :total-visible="10"
                    ></v-pagination>
                  </v-row>
                </v-card-actions>
                <!-- <v-data-table
                v-if="questions.length > 0"
                v-model="questionListSelected"
                :headers="tableHeadersQuestionList"
                :items="questions"
                item-key="_id"
                show-select
                class="elevation-1"
                hide-default-footer
                :page.sync="page"
              >
                <template v-slot:item.question="{ item }">
                  <span>{{ item.question }}</span>
                </template>

                <template v-slot:item.name="{ item }">
                  <span>{{ item.name }}</span>
                </template>

                <template v-slot:item.score="{ item }">
                  <span class="pl-3">{{ item.score }}</span>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-btn
                    class="ma-2 body-2 primary--text text-capitalize"
                    color="white"
                    depressed
                    @click="editQuestion(item._id, item.typeQuestion, null)"
                  >
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseList.edit'
                      )
                    }}
                  </v-btn>
                  <v-divider vertical class="divider-data-table"></v-divider>
                  <v-btn
                    class="ma-2 body-2 error--text text-capitalize"
                    color="white"
                    depressed
                    @click="confirmDelete(item._id)"
                  >
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseList.delete'
                      )
                    }}
                  </v-btn>
                </template>
              </v-data-table> -->

                <!-- end question list -->
                <button-add-exam
                  :isOpen.sync="dialog"
                  :examId.sync="examId"
                  :examFormat.sync="choiceType"
                  :questionId.sync="questionId"
                  :questionType.sync="questionType"
                  :closeDialogExam.sync="closeDialogExam"
                  :articleId.sync="articleId"
                />

                <v-dialog v-model="dialogDelete" persistent max-width="500">
                  <v-card>
                    <v-card-title class="headline">{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.deleteQuestionConfirm'
                      )
                    }}</v-card-title>
                    <v-card-text>{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.deleteQuestionConfirmDetail'
                      )
                    }}</v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="grey darken-1"
                        dark
                        outlined
                        @click="dialogDelete = false"
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.cancel'
                          )
                        }}</v-btn
                      >
                      <v-btn
                        color="error darken-1"
                        dark
                        @click="deleteItemQuestion(delQuestionId)"
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.confirm'
                          )
                        }}</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDeleteSuccess" max-width="500">
                  <v-card>
                    <v-card-title class="headline">{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.deleteDone'
                      )
                    }}</v-card-title>

                    <v-card-text>{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.deleteDoneDetail'
                      )
                    }}</v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn
                        color="green darken-1"
                        text
                        @click="dialogDeleteSuccess = false"
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.done'
                          )
                        }}</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog
                  v-model="dialogMultiDelete"
                  persistent
                  max-width="500"
                >
                  <v-card>
                    <v-card-title class="headline">{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.deleteMultiConfirm'
                      )
                    }}</v-card-title>
                    <v-card-text>{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.deleteQuestionConfirmDetail'
                      )
                    }}</v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        elevation="0"
                        class="mb-0 body-2 grey--text text-capitalize"
                        color="grey darken-1"
                        outlined
                        :disabled="this.loadingDelete == true"
                        @click="dialogMultiDelete = false"
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.cancel'
                          )
                        }}</v-btn
                      >
                      <v-btn
                        color="error darken-1"
                        :disabled="this.loadingDelete == true"
                        @click="deleteMultiQuestion()"
                        ><p v-if="loadingDelete == false" class="pa-0 ma-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.confirm'
                            )
                          }}
                        </p>
                        <p v-if="loadingDelete == true" class="pa-0 ma-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.doingDelete'
                            )
                          }}
                        </p></v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogMultiDeleteSuccess" max-width="500">
                  <v-card>
                    <v-card-title class="headline">{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.deleteDone'
                      )
                    }}</v-card-title>

                    <v-card-text>{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.deleteDoneDetail'
                      )
                    }}</v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn
                        color="green darken-1"
                        text
                        @click="dialogMultiDeleteSuccess = false"
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.done'
                          )
                        }}</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog
                  v-model="dialogImportExam"
                  max-width="750px"
                  persistent
                >
                  <v-card tile>
                    <v-toolbar
                      flat
                      dark
                      color="rgb(51, 97, 137)"
                      class="toolbarStyle"
                    >
                      <v-toolbar-title>
                        <v-icon left>mdi-format-annotation-plus</v-icon
                        >เพิ่มข้อสอบ
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-tooltip left>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            dark
                            @click="dialogImportExam = false"
                            v-on="on"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span class="subtitle-1">ปิดหน้าต่าง</span>
                      </v-tooltip>
                    </v-toolbar>
                    <br />
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <v-row>
                            <v-col lg="4" md="4" sm="6" xs="12" cols="12">
                              <div
                                class="
                                  lecture-type-card
                                  text-center
                                  d-flex
                                  justify-center
                                  align-center
                                "
                                @click="dialogExcelSingle = true"
                              >
                                <v-icon left>mdi-check-box-outline</v-icon>
                                <v-span class="textInbutton title"
                                  >ตัวเลือกเดียว</v-span
                                >
                              </div>
                            </v-col>

                            <v-col lg="4" md="4" sm="6" xs="12" cols="12">
                              <div
                                class="
                                  lecture-type-card
                                  text-center
                                  d-flex
                                  justify-center
                                  align-center
                                "
                                @click="dialogExcelMulti = true"
                              >
                                <v-icon left
                                  >mdi-check-box-multiple-outline</v-icon
                                >
                                <v-span class="textInbutton title"
                                  >หลายตัวเลือก</v-span
                                >
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <div style="flex: 1 1 auto"></div>
                  </v-card>
                </v-dialog>

                <v-dialog
                  v-model="dialogExcelSingle"
                  scrollable
                  persistent
                  width="1300px"
                >
                  <v-card>
                    <v-card-title>
                      <span>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.importSingleChoice'
                          )
                        }}</span
                      >
                      <v-spacer></v-spacer>
                      <v-btn icon light @click="dialogExcelSingle = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <span v-if="typeOfExam == false">
                            <strong class="font-weight-bold">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.msg20'
                                )
                              }}<br />
                              <label
                                >"{{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.msg21'
                                  )
                                }}"</label
                              >
                            </strong>
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.msg22'
                              )
                            }}
                            <label class="font-weight-bold">{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.msg23'
                              )
                            }}</label>
                          </span>

                          <span v-if="typeOfExam == true">
                            <strong class="font-weight-bold">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.msg20'
                                )
                              }}<br />
                              <label
                                >"{{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.msg21'
                                  )
                                }}"</label
                              >
                            </strong>
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.msg22'
                              )
                            }}
                            <label class="font-weight-bold">{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.msg23'
                              )
                            }}</label>
                            <br />
                            <strong class="font-weight-bold">
                              <label
                                >"{{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.mssg24'
                                  )
                                }}"</label
                              >
                            </strong>
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.mssg25'
                              )
                            }}
                          </span>
                        </v-col>
                      </v-row>
                      <v-row v-if="typeOfExam == true">
                        <v-col>
                          <h4 class="font-weight-black">
                            1.
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.chooseQuestionGroup'
                              )
                            }}
                          </h4>
                        </v-col>
                      </v-row>
                      <v-row v-if="typeOfExam == true">
                        <v-col cols="12">
                          <v-data-table
                            :loading="loadingImport"
                            :headers="tableHeaderLevels"
                            :items="arrTagLevelImport"
                            :page.sync="pageLevelImport"
                            hide-default-footer
                            class="elevation-1"
                          >
                            <template v-slot:item.numberOfQuestion="{ item }">
                              {{ item.numberOfQuestion }}
                            </template>
                            <template v-slot:item.score="{ item }">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.perQuestion'
                                ) + item.score
                              }}
                            </template>
                            <template v-slot:item.id="{ item }">
                              {{ item.id + ' ' }}
                              <span>
                                <v-btn
                                  small
                                  elevation="0"
                                  class="
                                    ml-3
                                    subtitle-2
                                    button-secondary
                                    font-weight-light
                                    text-capitalize
                                  "
                                  outlined
                                  @click="copyToClipBoard(item)"
                                  >{{
                                    $vuetify.lang.t(
                                      '$vuetify.defaultLayout.copy'
                                    )
                                  }}
                                </v-btn>
                              </span>
                            </template>
                          </v-data-table>
                          <v-snackbar
                            v-model="snackbar"
                            :vertical="vertical"
                            :timeout="2000"
                            absolute
                            centered
                            >{{
                              $vuetify.lang.t('$vuetify.defaultLayout.copied')
                            }}
                          </v-snackbar>
                          <v-row justify="center" class="my-3">
                            <v-pagination
                              v-model="pageLevelImport"
                              :length="pageLevelImportLength"
                              @input="changePageLevelImport"
                              color="rgb(66, 154, 216)"
                              :total-visible="10"
                            ></v-pagination>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col>
                          <h4
                            v-if="typeOfExam == false"
                            class="font-weight-black"
                          >
                            1.
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.downloadSample'
                              )
                            }}
                          </h4>
                          <h4
                            v-if="typeOfExam == true"
                            class="font-weight-black"
                          >
                            2.
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.downloadSample'
                              )
                            }}
                          </h4>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <a
                            :href="
                              typeOfExam == true
                                ? templateSingleCustomizable
                                : templateSingle
                            "
                          >
                            <v-btn
                              class="
                                float-left
                                ml-auto
                                button-primary
                                text-capitalize
                              "
                              dark
                            >
                              <v-icon left>mdi-download-outline</v-icon
                              >{{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.downloadSample'
                                )
                              }}
                            </v-btn>
                          </a>
                        </v-col>
                      </v-row>
                      <v-row class="mt-5">
                        <v-col>
                          <h4
                            v-if="typeOfExam == false"
                            class="font-weight-black"
                          >
                            2.
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.uploadFile'
                              )
                            }}
                          </h4>
                          <h4
                            v-if="typeOfExam == true"
                            class="font-weight-black"
                          >
                            3.
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.uploadFile'
                              )
                            }}
                          </h4>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="5">
                          <upload-excel-component
                            :on-success="handlePreviewSuccess"
                            :before-upload="beforeUpload"
                            :isFile.sync="isExcelFile"
                            :excel-type="'exam'"
                          />
                        </v-col>
                      </v-row>
                      <v-row class="mt-5" v-if="tableData.length > 0">
                        <v-col>
                          <h4 class="font-weight-black">
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.sampleImportData'
                              )
                            }}
                          </h4>
                        </v-col>
                      </v-row>
                      <!-- new data example -->
                      <v-card class="mb-5" v-if="tableData.length > 0">
                        <v-container class="container-import-exam pa-4">
                          <v-row class="px-1">
                            <v-col
                              cols="12"
                              v-for="item in tableTempData"
                              :key="item.no"
                            >
                            <!-- <v-slide-y-transition> -->
                            <!-- <transition name="slide-fade"> -->
                              <v-card >
                                <v-card-text>
                                  <v-list-item three-line>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        >{{ item.no }}.
                                        {{ item.question }} ?</v-list-item-title
                                      >
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_1 != undefined"
                                      >
                                        <span class="choise"> Choice 1. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_1 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_2 != undefined"
                                      >
                                        <span class="choise"> Choice 2. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_2 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_3 != undefined"
                                      >
                                        <span class="choise"> Choice 3. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_3 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_4 != undefined"
                                      >
                                        <span class="choise"> Choice 4. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_4 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_5 != undefined"
                                      >
                                        <span class="choise"> Choice 5. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_5 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_6 != undefined"
                                      >
                                        <span class="choise"> Choice 6. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_6 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_7 != undefined"
                                      >
                                        <span class="choise"> Choice 7. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_7 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_8 != undefined"
                                      >
                                        <span class="choise"> Choice 8. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_8 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_9 != undefined"
                                      >
                                        <span class="choise"> Choice 9. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_9 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_10 != undefined"
                                      >
                                        <span class="choise"> Choice 10. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_10 }}
                                        </span>
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-row class="mx-6" no-gutters>
                                    <v-col cols="8">
                                      <v-row>
                                        <v-col cols="4" v-if="item.text">
                                          <v-alert
                                            text
                                            color="info"
                                            class="text-left"
                                          >
                                            <span>question group : </span>
                                            <span class="black--text">
                                              {{ item.text }}
                                            </span>
                                          </v-alert>
                                        </v-col>
                                        <v-col cols="3">
                                          <v-alert
                                            text
                                            color="info"
                                            :class="
                                              item.text
                                                ? 'text-center'
                                                : 'text-left'
                                            "
                                          >
                                            <span>Mark : </span>
                                            <span class="black--text">
                                              {{ item.score }} Marks
                                            </span>
                                          </v-alert>
                                        </v-col>
                                        <v-col cols="4">
                                          <v-alert
                                            text
                                            color="info"
                                            class="text-center"
                                          >
                                            <span>Correct Answer : </span>
                                            <span class="black--text">
                                              {{ item.answer }}
                                            </span>
                                          </v-alert>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                  <v-row class="mx-6" no-gutters>
                                    <v-col cols="12">
                                      <v-alert text color="info">
                                        <span>Answer Description : </span>
                                        <span class="black--text">
                                          {{ item.answer_description }}
                                        </span>
                                      </v-alert>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                                
                              <v-overlay
                                :absolute="true"
                                :value="showStatus[item.no-1]"
                                color="success"
                                opacity="0.1"
                              >
                                <v-icon color="green" :size="30">mdi-check</v-icon>
                              </v-overlay>
                              </v-card>
                            <!-- </transition> -->
                            <!-- </v-slide-y-transition> -->
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                      <!-- end data example -->
                    </v-card-text>
                    <div class="text-center mb-5" v-if="tableData.length > 0">
                      <v-pagination
                        v-model="excelpages"
                        :length="Math.ceil(tableData.length / perPage)"
                        @input="paginationManual"
                      ></v-pagination>
                    </div>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        elevation="0"
                        class="
                          px-9
                          ma-2
                          subtitle-2
                          button-secondary
                          font-weight-light
                          text-capitalize
                        "
                        outlined
                        @click="closeExcelDialog"
                        :disabled="uploading"
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.cancel'
                          )
                        }}</v-btn
                      >
                      <v-btn
                        elevation="0"
                        class="
                          px-10
                          ma-2
                          subtitle-2
                          text-capitalize
                          font-weight-light
                          button-primary
                        "
                        @click="importExcel('single')"
                        :loading="uploading"
                        :disabled="
                          tableData < 1 ||
                          boolDisable == true ||
                          uploading ||
                          canImport == false
                        "
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.confirmToImport'
                          )
                        }}
                        <template v-slot:importExcel>
                          <span>{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.uploading'
                            )
                          }}</span>
                        </template></v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog
                  v-model="dialogExcelMulti"
                  scrollable
                  persistent
                  width="1300px"
                >
                  <v-card>
                    <v-card-title>
                      <span>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.importMultiChoice'
                          )
                        }}</span
                      >
                      <v-spacer></v-spacer>
                      <v-btn icon light @click="dialogExcelMulti = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <span v-if="typeOfExam == false">
                            <strong class="font-weight-bold">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.msg24'
                                )
                              }}<br />
                              <label
                                >"{{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.msg25'
                                  )
                                }}"</label
                              >
                            </strong>
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.msg26'
                              )
                            }}
                            <label class="font-weight-bold">{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.msg27'
                              )
                            }}</label>
                          </span>
                          <span v-if="typeOfExam == true">
                            <strong class="font-weight-bold">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.msg24'
                                )
                              }}<br />
                              <label
                                >"{{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.msg25'
                                  )
                                }}"</label
                              >
                            </strong>
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.msg26'
                              )
                            }}
                            <label class="font-weight-bold">{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.msg27'
                              )
                            }}</label>
                            <br />
                            <strong class="font-weight-bold">
                              <label
                                >"{{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.mssg24'
                                  )
                                }}"</label
                              >
                            </strong>

                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.mssg25'
                              )
                            }}
                          </span>
                        </v-col>
                      </v-row>
                      <v-row v-if="typeOfExam == true">
                        <v-col>
                          <h4 class="font-weight-black">
                            1.
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.chooseQuestionGroup'
                              )
                            }}
                          </h4>
                        </v-col>
                      </v-row>
                      <v-row v-if="typeOfExam == true">
                        <v-col cols="12">
                          <v-data-table
                            :loading="loadingImport"
                            :headers="tableHeaderLevels"
                            :items="arrTagLevelImport"
                            :page.sync="pageLevelImport"
                            hide-default-footer
                            class="elevation-1"
                          >
                            <template v-slot:item.numberOfQuestion="{ item }">
                              {{ item.numberOfQuestion }}
                            </template>
                            <template v-slot:item.score="{ item }">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.perQuestion'
                                ) + item.score
                              }}
                            </template>
                            <template v-slot:item.id="{ item }">
                              {{ item.id + ' ' }}
                              <span>
                                <v-btn
                                  small
                                  elevation="0"
                                  class="
                                    ml-3
                                    subtitle-2
                                    button-secondary
                                    font-weight-light
                                    text-capitalize
                                  "
                                  outlined
                                  @click="copyToClipBoard(item)"
                                  >{{
                                    $vuetify.lang.t(
                                      '$vuetify.defaultLayout.copy'
                                    )
                                  }}
                                </v-btn>
                              </span>
                            </template>
                          </v-data-table>
                          <v-snackbar
                            v-model="snackbar"
                            :vertical="vertical"
                            :timeout="2000"
                            absolute
                            centered
                            >{{
                              $vuetify.lang.t('$vuetify.defaultLayout.copied')
                            }}
                          </v-snackbar>
                          <v-row align="center" justify="center" class="my-3">
                            <v-pagination
                              v-model="pageLevelImport"
                              :length="pageLevelImportLength"
                              @input="changePageLevelImport"
                              color="rgb(66, 154, 216)"
                            ></v-pagination>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col>
                          <h4
                            v-if="typeOfExam == false"
                            class="font-weight-black"
                          >
                            1.
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.downloadSample'
                              )
                            }}
                          </h4>
                          <h4
                            v-if="typeOfExam == true"
                            class="font-weight-black"
                          >
                            2.
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.downloadSample'
                              )
                            }}
                          </h4>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <a
                            :href="
                              typeOfExam == true
                                ? templateMultiCustomizable
                                : templateMulti
                            "
                          >
                            <v-btn
                              class="
                                float-left
                                ml-auto
                                button-primary
                                text-capitalize
                              "
                              dark
                            >
                              <v-icon left>mdi-download-outline</v-icon
                              >{{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.downloadSample'
                                )
                              }}
                            </v-btn>
                          </a>
                        </v-col>
                      </v-row>
                      <v-row class="mt-5">
                        <v-col>
                          <h4
                            v-if="typeOfExam == false"
                            class="font-weight-black"
                          >
                            2.
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.uploadFile'
                              )
                            }}
                          </h4>
                          <h4
                            v-if="typeOfExam == true"
                            class="font-weight-black"
                          >
                            3.
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.uploadFile'
                              )
                            }}
                          </h4>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="5">
                          <upload-excel-component
                            :on-success="handlePreviewSuccess"
                            :before-upload="beforeUpload"
                            :isFile.sync="isExcelFile"
                            :excel-type="'exam'"
                          />
                        </v-col>
                      </v-row>
                      <v-row class="mt-5" v-if="tableData.length > 0">
                        <v-col>
                          <h4 class="font-weight-black">
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.sampleImportData'
                              )
                            }}
                          </h4>
                        </v-col>
                      </v-row>

                      <!-- new data example -->
                      <v-card class="mb-5" v-if="tableData.length > 0">
                        <v-container class="container-import-exam pa-4">
                          <v-row class="px-1">
                            <v-col
                              cols="12"
                              v-for="item in tableTempData"
                              :key="item.no"
                            >
                            <!-- <v-slide-x-transition> -->
                            <!-- <transition name="slide-fade"> -->
                              <v-card >
                                <v-card-text>
                                  <v-list-item three-line>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        >{{ item.no }}.
                                        {{ item.question }} ?</v-list-item-title
                                      >
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_1 != undefined"
                                      >
                                        <span class="choise"> Choise 1. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_1 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_2 != undefined"
                                      >
                                        <span class="choise"> Choise 2. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_2 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_3 != undefined"
                                      >
                                        <span class="choise"> Choise 3. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_3 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_4 != undefined"
                                      >
                                        <span class="choise"> Choise 4. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_4 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_5 != undefined"
                                      >
                                        <span class="choise"> Choise 5. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_5 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_6 != undefined"
                                      >
                                        <span class="choise"> Choise 6. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_6 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_7 != undefined"
                                      >
                                        <span class="choise"> Choise 7. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_7 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_8 != undefined"
                                      >
                                        <span class="choise"> Choise 8. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_8 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_9 != undefined"
                                      >
                                        <span class="choise"> Choise 9. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_9 }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        class="body-1"
                                        v-if="item.choice_10 != undefined"
                                      >
                                        <span class="choise"> Choise 10. </span>
                                        <span class="font-weight-medium">
                                          {{ item.choice_10 }}
                                        </span>
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-row class="mx-6" no-gutters>
                                    <v-col cols="8">
                                      <v-row>
                                        <v-col cols="4" v-if="item.text">
                                          <v-alert
                                            text
                                            color="info"
                                            class="text-left"
                                          >
                                            <span>question group : </span>
                                            <span class="black--text">
                                              {{ item.text }}
                                            </span>
                                          </v-alert>
                                        </v-col>
                                        <v-col cols="3">
                                          <v-alert
                                            text
                                            color="info"
                                            :class="
                                              item.text
                                                ? 'text-center'
                                                : 'text-left'
                                            "
                                          >
                                            <span>Mark : </span>
                                            <span class="black--text">
                                              {{ item.score }} Marks
                                            </span>
                                          </v-alert>
                                        </v-col>
                                        <v-col cols="4">
                                          <v-alert
                                            text
                                            color="info"
                                            class="text-center"
                                          >
                                            <span>Correct Answer : </span>
                                            <span class="black--text">
                                              {{ item.answer }}
                                            </span>
                                          </v-alert>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                  <v-row class="mx-6" no-gutters>
                                    <v-col cols="12">
                                      <v-alert text color="info">
                                        <span>Answer Description : </span>
                                        <span class="black--text">
                                          {{ item.answer_description }}
                                        </span>
                                      </v-alert>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                                <v-overlay
                                  :absolute="true"
                                  :value="showStatus[item.no-1]"
                                  color="success"
                                  opacity="0.1"
                                >
                                  <v-icon color="green" :size="30">mdi-check</v-icon>
                                </v-overlay>
                              </v-card>
                              <!-- </transition> -->
                              
                            <!-- </v-slide-x-transition> -->
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                      <!-- end data example -->
                    </v-card-text>
                    <div class="text-center mb-5" v-if="tableData.length > 0">
                      <v-pagination
                        v-model="excelpages"
                        :length="Math.ceil(tableData.length / perPage)"
                        @input="paginationManual"
                      ></v-pagination>
                    </div>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        elevation="0"
                        class="
                          px-9
                          ma-2
                          subtitle-2
                          button-secondary
                          font-weight-light
                          text-capitalize
                        "
                        outlined
                        @click="closeExcelDialog"
                        :disabled="uploading"
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.cancel'
                          )
                        }}</v-btn
                      >
                      <v-btn
                        elevation="0"
                        class="
                          px-10
                          ma-2
                          subtitle-2
                          text-capitalize
                          font-weight-light
                          button-primary
                        "
                        @click="importExcel('multiple')"
                        :loading="uploading"
                        :disabled="
                          tableData < 1 ||
                          boolDisable == true ||
                          uploading ||
                          canImport == false
                        "
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.confirmToImport'
                          )
                        }}
                        <template v-slot:importExcel>
                          <span>{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.uploading'
                            )
                          }}</span>
                        </template></v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="dialoguploadWarning" max-width="500">
                  <v-card>
                    <v-card-title class="headline">{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.failedUpload'
                      )
                    }}</v-card-title>
                    <div class="px-5">
                      <v-card-text class="subtitle-1">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.failedUploadDetail'
                          )
                        }}
                      </v-card-text>
                    </div>
                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn
                        color="primary darken-1"
                        text
                        @click="dialoguploadWarning = false"
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.ok'
                          )
                        }}</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog
                  v-model="noQuestionDialog"
                  persistent
                  max-width="350"
                  color="white"
                >
                  <v-card class="pa-3">
                    <v-card-title class="mb-3">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.EnableSuspend'
                        )
                      }}
                    </v-card-title>
                    <v-card-text>
                      <p class="subtitle-1 font-weight-light pb-10">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.noQuestion'
                          )
                        }}
                      </p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="green darken-1"
                        text
                        @click="closeNoQuestionDialog"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.confirm'
                          )
                        }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog
                  v-model="dialogModify"
                  scrollable
                  persistent
                  width="600"
                >
                  <v-card>
                    <v-toolbar flat dark color="rgb(51, 97, 137)">
                      <v-toolbar-title>
                        <v-icon left>mdi-playlist-edit</v-icon
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.modifyExam'
                          )
                        }}
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-tooltip left>
                        <template v-slot:activator="{ on }">
                          <v-btn icon dark @click="closeDialogModify" v-on="on">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span class="subtitle-1">{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.close'
                          )
                        }}</span>
                      </v-tooltip>
                    </v-toolbar>
                    <v-card-text class="pa-0">
                      <v-card class="mx-auto">
                        <draggable
                          :list="questionsList"
                          :disabled="!enabled"
                          class="list-group"
                          ghost-class="ghost"
                          @end="checkMoveQuestion"
                        >
                          <div
                            v-for="(question, index) in questionsList"
                            :key="question._id"
                          >
                            <v-list class="py-0" two-line>
                              <v-list-item v-if="question.children.length == 0">
                                <v-list-item-content class="pa-0">
                                  <v-list-item-title>
                                    <span
                                      class="subtitle-1 font-weight-light mr-2"
                                      >{{
                                        $vuetify.lang.t(
                                          '$vuetify.courseManagement.lectureStep.insertExam.num'
                                        ) +
                                        ' ' +
                                        (index + 1) +
                                        ' '
                                      }}</span
                                    >
                                    {{ question.question }}
                                  </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action-text>
                                  <v-list-item-subtitle class="ma-0 body-2">
                                    <!-- <v-icon>{{ question.icon }}</v-icon> -->
                                    {{ question.name }}
                                  </v-list-item-subtitle>
                                </v-list-item-action-text>
                                <v-list-item-avatar class="my-0">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-btn icon v-on="on">
                                        <v-icon>mdi-menu</v-icon>
                                      </v-btn>
                                    </template>
                                    <span class="subtitle-1">{{
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.drag'
                                      )
                                    }}</span>
                                  </v-tooltip>
                                </v-list-item-avatar>
                              </v-list-item>

                              <v-list-item
                                v-if="question.children.length > 0"
                                class="article-order"
                              >
                                <v-list-item-content class="pa-0">
                                  <v-list-item-title>
                                    <span
                                      class="
                                        subtitle-1
                                        my-auto
                                        font-weight-light
                                        mr-2
                                      "
                                    >
                                      {{
                                        $vuetify.lang.t(
                                          '$vuetify.courseManagement.lectureStep.insertExam.num'
                                        ) +
                                        ' ' +
                                        (index + 1) +
                                        ' '
                                      }}
                                    </span>
                                    {{ question.question }}
                                  </v-list-item-title>
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-on="on"
                                        @click="openExpand(index, 'order')"
                                        icon
                                        class="
                                          md-position-absolute
                                          centerx-ele
                                          mt-3
                                          active
                                        "
                                        :id="`centerx-ele-${index}`"
                                      >
                                        <v-icon class="icon"
                                          >mdi-chevron-down</v-icon
                                        >
                                      </v-btn>
                                    </template>
                                    <span class="subtitle-1">{{
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.clickToHideOrShow'
                                      )
                                    }}</span>
                                  </v-tooltip>
                                </v-list-item-content>
                                <v-list-item-action-text>
                                  <v-list-item-subtitle class="body-2">
                                    {{ question.name }}
                                  </v-list-item-subtitle>
                                </v-list-item-action-text>
                                <v-list-item-avatar class="my-0">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-btn icon v-on="on">
                                        <v-icon>mdi-menu</v-icon>
                                      </v-btn>
                                    </template>
                                    <span class="subtitle-1">{{
                                      $vuetify.lang.t(
                                        '$vuetify.courseManagement.lectureStep.insertExam.drag'
                                      )
                                    }}</span>
                                  </v-tooltip>
                                </v-list-item-avatar>
                              </v-list-item>

                              <v-divider></v-divider>
                            </v-list>
                            <!-- article child -->
                            <div
                              class="expand-panel active mt-0"
                              :id="`expand-${index}`"
                            >
                              <draggable
                                :list="question.children"
                                :disabled="!enabled"
                                class="list-group"
                                ghost-class="ghost"
                                @end="checkMoveQuestion"
                              >
                                <div
                                  v-for="(
                                    child, indexChild
                                  ) in question.children"
                                  :key="child._id"
                                >
                                  <v-list-item class="pl-8 article-order-child">
                                    <v-list-item-content class="pa-0">
                                      <v-list-item-title>
                                        <span
                                          class="
                                            subtitle-2
                                            my-auto
                                            font-weight-light
                                            mr-2
                                          "
                                          >{{
                                            $vuetify.lang.t(
                                              '$vuetify.courseManagement.lectureStep.insertExam.num'
                                            ) +
                                            ' ' +
                                            (index + 1) +
                                            '.' +
                                            (indexChild + 1) +
                                            ' '
                                          }}</span
                                        >
                                        {{ child.question }}
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action-text>
                                      <v-list-item-subtitle class="body-2">
                                        {{ child.name }}
                                      </v-list-item-subtitle>
                                    </v-list-item-action-text>
                                    <v-list-item-action>
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                          <v-btn icon v-on="on">
                                            <v-icon>mdi-menu</v-icon>
                                          </v-btn>
                                        </template>
                                        <span class="subtitle-1">{{
                                          $vuetify.lang.t(
                                            '$vuetify.courseManagement.lectureStep.insertExam.drag'
                                          )
                                        }}</span>
                                      </v-tooltip>
                                    </v-list-item-action>
                                  </v-list-item>
                                  <v-divider
                                    v-show="indexChild != child.length - 1"
                                    class="ma-0"
                                  ></v-divider>
                                </div>
                              </draggable>
                            </div>
                            <!-- end article child -->
                          </div>
                        </draggable>
                      </v-card>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-row>
      </v-container>

      <v-dialog v-model="dialogSuccess" max-width="500">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.saveDone'
            )
          }}</v-card-title>

          <v-card-text></v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="dialogSuccess = false">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.done'
              )
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDeleteTagLevel" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.confirmDeleteQuestionGroup'
            )
          }}</v-card-title>
          <v-card-text>{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.confirmDeleteQuestionGroupDetail'
            )
          }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              dark
              outlined
              @click="dialogDeleteTagLevel = false"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.cancel'
                )
              }}</v-btn
            >
            <v-btn
              color="error darken-1"
              dark
              @click="deleteTagLevel(idTagLevel)"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.confirm'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDeleteTagLevelSuccess" max-width="500">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.deleteQuestionGroupDone'
            )
          }}</v-card-title>

          <v-card-text>{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.deleteQuestionGroupDoneDetail'
            )
          }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click="dialogDeleteTagLevelSuccess = false"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.done'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDuplicade" max-width="500">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.savingFailed'
            )
          }}</v-card-title>

          <v-card-text>{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.questionGroupDuplicate'
            )
          }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              text
              @click="dialogDuplicade = false"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.ok'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="warnningToSaveDialog" max-width="500">
        <v-card>
          <v-card-title class="headline">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.alertLeavePageTitle'
              )
            }}
          </v-card-title>
          <v-card-text>
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.alertLeavePageSubTitle'
              )
            }}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              elevation="0"
              class="mb-0 body-2 text-capitalize"
              color="white"
              @click="warnningToSaveDialog = false"
            >
              <p class="mb-0">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertYoutube.continue'
                  )
                }}
              </p>
            </v-btn>

            <v-btn
              elevation="0"
              class="mb-0 body-2 text-primary text-capitalize"
              color="white"
              @click="closeLectureExamDialog"
            >
              <p class="mb-0">
                {{
                  $vuetify.lang.t('$vuetify.courseManagement.lectureStep.exit')
                }}
              </p>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogFail" max-width="500">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.savingFailed'
            )
          }}</v-card-title>
          <v-card-text v-if="time == true && mins == 0 && secs == 0"
            >-
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.failedMsg1'
              )
            }}</v-card-text
          >
          <v-card-text v-if="repeat == 5 && repeatTimes == 0"
            >-
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.failedMsg2'
              )
            }}</v-card-text
          >

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              elevation="0"
              class="mb-0 body-2 text-primary text-capitalize"
              color="white"
              @click="dialogFail = false"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.ok'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogSaveFail"
        persistent
        max-width="500"
        color="white"
      >
        <v-card class="pa-3">
          <v-card-title class="mb-3">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.savingFailed'
            )
          }}</v-card-title>
          <v-card-text>
            <p class="subtitle-1">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.saveFailMsg'
                )
              }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              elevation="0"
              class="mb-0 body-2 text-primary text-capitalize"
              color="white"
              @click="dialogSaveFail = false"
              >{{
                $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="previewExamFailDialog"
        persistent
        max-width="500"
      >
        <v-card >
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.importFailed'
            )
          }}</v-card-title>
          <v-card-text>
              <!-- {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.importError'
                )
              }}
              {{importErrorAtQuestion}} -->

              <span v-html="$vuetify.lang.t('$vuetify.courseManagement.lectureStep.insertExam.importError')" />
              <span ><b>{{importErrorAtQuestion}}</b> </span>
              <div v-html="$vuetify.lang.t('$vuetify.courseManagement.lectureStep.insertExam.importErrorAndCheckAgain')" />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="primary darken-1"
              @click="previewExamFailDialog = false"
              >{{
                $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogImportFail"
        persistent
        max-width="500"
      >
        <v-card >
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.importFailed'
            )
          }}</v-card-title>
          <v-card-text>
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.importAgain'
                )
              }}  {{importIndex}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="primary darken-1"
              @click="closeImportFailDialog"
              >{{
                $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Single choice dialog -->
      <single-choice-dialog
        :isOpen.sync="dialog_singleChoice"
        :examId.sync="examId"
        :randomChoices.sync="randomChoices"
        :examFormat.sync="choiceType"
        :questionId.sync="questionId"
        :randomSetting.sync="chooseRandomQuestion"
        :reorderQuestion="reorderQuestion"
        :closeDialog="closeDialog"
        :closeExamDialog="closeExamDialog"
        :articleId="articleId"
      />

      <!-- Multi choice dialog -->
      <multi-choice-dialog
        :isOpen.sync="dialog_multiChoice"
        :examId.sync="examId"
        :randomChoices.sync="randomChoices"
        :examFormat.sync="choiceType"
        :questionId.sync="questionId"
        :randomSetting.sync="chooseRandomQuestion"
        :reorderQuestion="reorderQuestion"
        :closeDialog="closeDialog"
        :closeExamDialog="closeExamDialog"
        :articleId="articleId"
      />

      <!-- Matching dialog -->
      <matching-dialog
        :isOpen.sync="dialog_matching"
        :examId.sync="examId"
        :randomChoices.sync="randomChoices"
        :examFormat.sync="choiceType"
        :questionId.sync="questionId"
        :randomSetting.sync="chooseRandomQuestion"
        :reorderQuestion="reorderQuestion"
        :closeDialog="closeDialog"
        :closeExamDialog="closeExamDialog"
        :articleId="articleId"
      />

      <!-- Fill word dialog -->
      <fill-word-dialog
        :isOpen.sync="dialog_fillWord"
        :examId.sync="examId"
        :examFormat.sync="choiceType"
        :questionId.sync="questionId"
        :randomSetting.sync="chooseRandomQuestion"
        :reorderQuestion="reorderQuestion"
        :closeDialog="closeDialog"
        :closeExamDialog="closeExamDialog"
        :articleId="articleId"
      />

      <!-- Exam Article dialog -->
      <exam-article-dialog
        :isOpen.sync="dialog_examArticle"
        :examId.sync="examId"
        :examFormat.sync="choiceType"
        :questionId.sync="questionId"
        :reorderQuestion="reorderQuestion"
        :closeDialog="closeDialog"
        :closeExamDialog="closeExamDialog"
        :articleId="articleId"
      />

      <!-- Descriptive dialog -->
      <descriptive-dialog
        :isOpen.sync="dialog_descriptive"
        :examId.sync="examId"
        :examFormat.sync="choiceType"
        :questionId.sync="questionId"
        :reorderQuestion="reorderQuestion"
        :closeDialog="closeDialog"
        :closeExamDialog="closeExamDialog"
        :articleId="articleId"
      />

      <game-exam-dialog
        :isOpen.sync="dialog_gameMaker"
        :examId.sync="examId"
        :randomChoices.sync="randomChoices"
        :examFormat.sync="choiceType"
        :questionId.sync="questionId"
        :reorderQuestion="reorderQuestion"
        @onClose="closeDialog"
        @onCloseExam="closeExamDialog"
        :articleId="articleId"
        :game-options="gameOptions"
      />
      <exam-review-dialog
        :isOpen.sync="dialog_review"
        :ticketId.sync="previewTicket"
        :closeDialog.sync="closeDialogReview"
      />
    </div>
    <div
      v-if="questions.length == 0 && main_tabs == 'question'"
      class="mb-0 mx-2 text-center"
    >
      <div class="mx-6 card-no-data">
        <p class="my-16 py-16 body-1 grey--text">No data available</p>
      </div>
    </div>
  </section>
</template>

<script>
// import draggable from "vuedraggable";
import { Datetime } from 'vue-datetime';
import {
  getExamById,
  getQuestionList,
  insertExam,
  updateExam,
  reorderQuestion,
  deleteQuestion,
  insertChoice,
  insertQuestion,
  shiftquestion,
  getQuestionArticleById,
  getQuestionListSwap,
  deleteQuestionAll,
  insertTagLevel,
  updateTagLevel,
  deleteTagLevel,
  getListTagLevel,
  updateExamRandomChoice,
  startStateAdmin,
  getAdminTicketDetail
} from '@/service/course/exam.js';
import buttonAddExam from '@/views/course/dialog/insertExamDialog.vue';
import {
  insertLecture,
  updateLecture,
  getCourseById,
} from '@/service/course/course';
import UploadExcelComponent from '@/views/course/lectures/exam/uploadQuestion';
import $ from 'jquery';
import singleChoiceDialog from '@/views/course/lectures/exam/singleChoice';
import multiChoiceDialog from '@/views/course/lectures/exam/multiChoice';
import matchingDialog from '@/views/course/lectures/exam/matching';
import fillWordDialog from '@/views/course/lectures/exam/fillInTheBlank';
import examArticleDialog from '@/views/course/lectures/exam/examArticle';
import descriptiveDialog from '@/views/course/lectures/exam/descriptive';
import gameExamDialog from '@/views/course/lectures/exam/gameExam';
import examReviewDialog from '@/views/course/lectures/exam/examReviewDialog';
export default {
  name: 'simple',
  display: 'Simple',
  order: 0,
  components: {
    datetime: Datetime,
    buttonAddExam,
    UploadExcelComponent,
    //dialog type exam
    singleChoiceDialog,
    multiChoiceDialog,
    matchingDialog,
    fillWordDialog,
    examArticleDialog,
    descriptiveDialog,
    gameExamDialog,
    examReviewDialog
  },
  data: function () {
    return {
      previewTicket: null,
      dialogPreviewTicket: false,
      item: 1,
      items: [
        { text: 'Real-Time', icon: 'mdi-clock' },
        { text: 'Audience', icon: 'mdi-account' },
        { text: 'Conversions', icon: 'mdi-flag' },
      ],
      examId: '',
      lectureId: '',
      sectionId: '',
      lectures: [],
      randomSetting: null,
      articleId: '',
      pageExamUploadCount: 0,
      pageExamUpload: 1,
      excelFile: '',
      isExcelFile: false,
      templateSingle:
        'https://s3-amr.deknerd.com/template/template-exam/single-choice-with-score.xlsx',
      templateSingleCustomizable:
        'https://s3-amr.deknerd.com/template/template-exam/single-choice-with-id.xlsx',

      templateMulti:
        'https://s3-amr.deknerd.com/template/template-exam/multi-choice-with-score.xlsx',
      templateMultiCustomizable:
        'https://s3-amr.deknerd.com/template/template-exam/multi-choice-with-id.xlsx',
      maxWidth: '40%',
      snackbar2: false,
      success: 'Success, creating course!',
      timeout: 5000,
      uploading: false,
      dialog: false,
      dialoguploadWarning: false,
      dialogExcelSingle: false,
      dialogExcelMulti: false,
      dialogImportExam: false,
      dialog_singleChoice: false,
      dialog_multiChoice: false,
      dialog_matching: false,
      dialog_descriptive: false,
      newLectureID: null,
      dialog_fillWord: false,
      dialog_writing: false,
      dialog_examArticle: false,
      dialog_gameMaker: false,
      notifications: false,
      dialogSuccess: false,
      dialogDelete: false,
      dialogDeleteSuccess: false,
      dialogDeleteTagLevel: false,
      dialogDeleteTagLevelSuccess: false,
      dialogImportFail: false,
      importIndex: 0,
      showStatus: [],
      delQuestionId: '',
      delTagLevelId: '',
      dialogFail: false,
      dialogModify: false,
      loadingDelete: false,
      dialogDuplicade: false,
      dialogSaveFail: false,

      sound: true,
      widgets: false,
      valid: true,
      value: 10,
      bufferValue: 100,
      interval: 0,
      nameRules: [(v) => !!v || 'กรุณากรอชื่อชุดข้อสอบ'],
      time: false,
      repeat: 0, // 0, 1, ...
      repeatTimes: 0,
      mins: 0,
      secs: 0,
      answer: 1, // 0, 1, 2
      choiceType: 'number', // "thai", "english", "number"
      totalRandom: 0,
      //drag variable
      enabled: true,
      list: [
        { name: 'John', id: 0 },
        { name: 'Joao', id: 1 },
        { name: 'Jean', id: 2 },
      ],
      tableData: [],
      tableTempData: [],
      perPage: 5,
      excelpages: 1,
      selectTagLevel: null,
      tableHeaderLevel: [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderLevel.questionGroupName'
          ),
          value: 'text',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderLevel.countRandom'
          ),
          value: 'numberOfQuestion',
          sortable: false,
          align: 'center',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderLevel.score'
          ),
          value: 'score',
          sortable: false,
          align: 'center',
        },

        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderLevel.ID'
          ),
          value: 'id',
          sortable: false,
          align: 'center',
        },
      ],
      tableHeaderNormal: [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.no'
          ),
          value: 'no',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.score'
          ),
          value: 'score',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.question'
          ),
          value: 'question',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.correctAns'
          ),
          value: 'answer',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.ansDescription'
          ),
          value: 'answer_description',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice1'
          ),
          value: 'choice_1',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice2'
          ),
          value: 'choice_2',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice3'
          ),
          value: 'choice_3',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice4'
          ),
          value: 'choice_4',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice5'
          ),
          value: 'choice_5',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice6'
          ),
          value: 'choice_6',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice7'
          ),
          value: 'choice_7',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice8'
          ),
          value: 'choice_8',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice9'
          ),
          value: 'choice_9',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice10'
          ),
          value: 'choice_10',
          sortable: false,
        },
      ],
      tableHeaderRandom: [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.no'
          ),
          value: 'no',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.questionGroup'
          ),
          value: 'question_group_id',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.score'
          ),
          value: 'score',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.question'
          ),
          value: 'question',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.correctAns'
          ),
          value: 'answer',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.ansDescription'
          ),
          value: 'answer_description',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice1'
          ),
          value: 'choice_1',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice2'
          ),
          value: 'choice_2',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice3'
          ),
          value: 'choice_3',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice4'
          ),
          value: 'choice_4',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice5'
          ),
          value: 'choice_5',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice6'
          ),
          value: 'choice_6',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice7'
          ),
          value: 'choice_7',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice8'
          ),
          value: 'choice_8',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice9'
          ),
          value: 'choice_9',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice10'
          ),
          value: 'choice_10',
          sortable: false,
        },
      ],
      dragging: false,

      questionId: null,
      articleQuestionId: null,
      oldQuestions: [],
      questions: [],
      questionsList: [],
      examDetail: null,
      questionType: null,

      title: '',
      description: '',

      randomQuestion: false,
      chooseRandomQuestion: false,
      conditionalRandom: false,
      resetTicket: false,
      settingLevel: false,
      // active: false,
      isModifyStartEndTime: false,
      startTime: '',
      endTime: '',

      // multi delete exam
      selected_exam: [],
      allSelected: false,
      dialogMultiDelete: false,
      dialogMultiDeleteSuccess: false,
      answerCorrect: [
        {
          text: '',
        },
      ],
      noQuestionDialog: false,

      warnningToSaveDialog: false,

      // paggination
      page: 1,
      limit: 10,
      pageCount: 1,
      pageLevel: 1,
      pageLevelLength: 1,
      pageLevelImport: 1,
      pageLevelImportLength: 1,

      changeOrder: null,
      boolean: false,
      countArticle: 0,
      main_tabs: 'detail',
      gameOptions: {},
      resultLecture: null,
      canImport: false,
      typeImport: null,
      tagLevel: '',
      arrTagLevel: [],
      arrTagLevelImport: [],
      loadingImport: false,
      arrTagLevelFilter: [],
      arrTagLevelForCheck: [],
      editLevel: false,
      temptext: '',

      bools: false,
      setNumberOfQuestion: 0,
      setScoreOfQuestion: 1,
      tagLevelList: [],
      typeOfExam: false,
      totalQuestion: 0,
      totalScore: 0,
      rating: 1,
      temp_text: '',
      loading: true,
      snackbar: false,
      vertical: true,
      boolDisable: false,
      randomChoices: false,
      setPercent: false,
      percentExam: 0,

      loadingbtn: false,
      courseId: '',
      isFirstEdit: false,
      questionGroupDialog: false,
      itemTaglevel: {
        id: '',
        text: '',
        numberOfQuestion: 0,
        score: 0,
        isAdd: false,
        index: '',
      },

      faceDetection: false,
      faceDetectionRandom: false,
      countNumberQuestion: 0,
      listCountQuestion: [],
      selectedNumberQuestion: [],
      faceDetectionLimit: 1,
      startTimeOld: '',

      loadingSaveTagLevel: false,
      previewExamFailDialog: false,

      dialog_review: false,
      ticketId: null,
      loadingTryExam: false,
      importErrorAtQuestion: ""
    };
  },
  computed: {
    tableHeadersQuestionGroup() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeadersQuestionGroup.questionGroupName'
          ),
          align: 'left',
          sortable: false,
          value: 'questionGroupName',
          width: 200,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeadersQuestionGroup.randomNumber'
          ),
          sortable: false,
          value: 'randomNumber',
          filterable: false,
          width: 130,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeadersQuestionGroup.totalNumber'
          ),
          value: 'totalNumber',
          sortable: false,
          filterable: false,
          width: 130,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeadersQuestionGroup.score'
          ),
          value: 'score',
          sortable: false,
          filterable: false,
          width: 190,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeadersQuestionGroup.totalScore'
          ),
          value: 'totalScore',
          sortable: false,
          filterable: false,
          width: 130,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeadersQuestionGroup.editQuestionGroup'
          ),
          value: 'action',
          sortable: false,
          filterable: false,
          class: 'pl-15',
          width: 230,
        },
      ];
    },
    startTimeRule() {
      const rules = [];

      if (this.isModifyStartEndTime === true) {
        const rule = (v) =>
          !!v ||
          this.$vuetify.lang.t('$vuetify.courseManagement.exam.startTime');

        rules.push(rule);
      }
      return rules;
    },
    endTimeRule() {
      const rules = [];

      if (this.isModifyStartEndTime === true) {
        const rule = (v) =>
          !!v || this.$vuetify.lang.t('$vuetify.courseManagement.exam.endTime');

        rules.push(rule);
      }
      return rules;
    },
    tableHeaderLevels() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderLevel.questionGroupName'
          ),
          value: 'text',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderLevel.countRandom'
          ),
          value: 'numberOfQuestion',
          sortable: false,
          align: 'center',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderLevel.score'
          ),
          value: 'score',
          sortable: false,
          align: 'center',
        },

        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderLevel.ID'
          ),
          value: 'id',
          sortable: false,
          align: 'center',
        },
      ];
    },
    tableHeaderNormals() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.no'
          ),
          value: 'no',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.score'
          ),
          value: 'score',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.question'
          ),
          value: 'question',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.correctAns'
          ),
          value: 'answer',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.ansDescription'
          ),
          value: 'answer_description',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice1'
          ),
          value: 'choice_1',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice2'
          ),
          value: 'choice_2',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice3'
          ),
          value: 'choice_3',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice4'
          ),
          value: 'choice_4',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice5'
          ),
          value: 'choice_5',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice6'
          ),
          value: 'choice_6',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice7'
          ),
          value: 'choice_7',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice8'
          ),
          value: 'choice_8',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice9'
          ),
          value: 'choice_9',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderNormal.choice10'
          ),
          value: 'choice_10',
          sortable: false,
        },
      ];
    },
    tableHeaderRandoms() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.no'
          ),
          value: 'no',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.questionGroup'
          ),
          value: 'question_group_id',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.score'
          ),
          value: 'score',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.question'
          ),
          value: 'question',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.correctAns'
          ),
          value: 'answer',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.ansDescription'
          ),
          value: 'answer_description',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice1'
          ),
          value: 'choice_1',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice2'
          ),
          value: 'choice_2',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice3'
          ),
          value: 'choice_3',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice4'
          ),
          value: 'choice_4',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice5'
          ),
          value: 'choice_5',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice6'
          ),
          value: 'choice_6',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice7'
          ),
          value: 'choice_7',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice8'
          ),
          value: 'choice_8',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice9'
          ),
          value: 'choice_9',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeaderRandom.choice10'
          ),
          value: 'choice_10',
          sortable: false,
        },
      ];
    },
    tableHeadersQuestionList() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.question'
          ),
          value: 'question',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeadersQuestionList.typeOfQuestion'
          ),
          value: 'name',
          sortable: false,
          align: 'start',
          width: 180,
        },
        // {
        //   text: this.$vuetify.lang.t(
        //     '$vuetify.courseManagement.lectureStep.insertExam.tableHeadersQuestionList.questionGroup'
        //   ),
        //   value: 'question_group_id',
        //   sortable: false,
        //   align: 'start',
        // },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeadersQuestionList.score'
          ),
          value: 'score',
          sortable: false,
          align: 'start',
          width: 120,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.tableHeadersQuestionList.actions'
          ),
          value: 'action',
          sortable: false,
          align: 'start',
          class: 'pl-15',
          width: 230,
        },
      ];
    },
  },
  watch: {
    isModifyStartEndTime(val) {
      if (val == false) {
        this.startTime = '';
        this.endTime = '';
      } else {
        let oneDayMilli = 86400000;
        let currentDate = new Date();
        let initStartDateMilli = new Date(currentDate.getTime()).toISOString();
        let initEndDateMilli = new Date(
          currentDate.getTime() + oneDayMilli
        ).toISOString();
        if (this.examDetail) {
          if (
            this.examDetail.startTime == 0 ||
            this.examDetail.startTime == null
          ) {
            this.startTime = initStartDateMilli;
          } else {
            this.startTime = new Date(this.examDetail.startTime).toISOString();
          }

          if (this.examDetail.endTime == 0 || this.examDetail.endTime == null) {
            this.endTime = initEndDateMilli;
          } else {
            this.endTime = new Date(this.examDetail.endTime).toISOString();
          }
        } else {
          this.startTime = initStartDateMilli;
          this.endTime = initEndDateMilli;
        }
      }
    },
    active(val) {
      if (val == true) {
        this.isModifyStartEndTime = false;
        if (this.examDetail) {
          if (this.examDetail.startTime > 0 || this.examDetail.endTime > 0) {
            this.isModifyStartEndTime = true;
          }
        }
      }
    },
    time(val) {
      if (val == false) {
        this.mins = 0;
        this.secs = 0;
      } else {
        if (this.examDetail) {
          let timeMilliSec = this.examDetail.timeUse;
          this.mins = parseInt(timeMilliSec / 1000.0 / 60.0);
          this.secs = (timeMilliSec / 1000.0) % 60.0;
        }
      }
    },
    repeatTimes(val) {
      if (val != 0 && val != 1) {
        this.repeat = 5;
      }
    },
    repeat(val) {
      if (val == 0) {
        this.repeatTimes = 0;
      } else if (val == 1) {
        this.repeatTimes = 1;
      } else {
        if (this.examDetail) {
          this.repeatTimes = this.examDetail.limited;
        }
      }
    },
    isOpen: async function (newValue) {
      await this.initialize(newValue);
      this.selected_exam = [];
      this.allSelected = false;
    },
    startTime(val) {
      if (this.startTimeOld != val) {
        let startDate = val.substring(0, 10);
        let startTime = val.substring(10, val.length);
        let endDateTime = new Date(startDate + startTime);
        let endDate = endDateTime.setDate(endDateTime.getDate() + 1);
        this.endTime = new Date(endDate).toISOString();
        this.startTimeOld = val;
      }
    },
  },
  methods: {
    async initialize(newValue) {
      if (newValue) {
        if (this.lectureId) {
          this.page = 1;
          this.newLectureID = this.lectureId;
          let filterLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];
          console.log('filterlecture');
          console.log(filterLecture);
          this.title = filterLecture.title;
          this.description = filterLecture.description;

          await this.getExamDetail(filterLecture.exams[0]._id);
          await this.getListTagLevel(filterLecture.exams[0]._id);
          await this.getListTagLevelForCheck(filterLecture.exams[0]._id);
          await this.getListTagLevelFilter(filterLecture.exams[0]._id);
          await this.getQuestionList(filterLecture.exams[0]._id);

          this.examId = filterLecture.exams[0]._id;
        } else if (this.newLectureID) {
          let filterLecture = this.lectures.filter(
            (lecture) => lecture._id === this.newLectureID
          )[0];
          this.title = filterLecture.title;
          this.description = filterLecture.description;

          await this.getExamDetail(filterLecture.exams[0]._id);
          await this.getListTagLevel(filterLecture.exams[0]._id);
          await this.getListTagLevelForCheck(filterLecture.exams[0]._id);
          await this.getListTagLevelFilter(filterLecture.exams[0]._id);
          await this.getQuestionList(filterLecture.exams[0]._id);

          this.examId = filterLecture.exams[0]._id;
        } else {
          this.main_tabs = 'detail';
          this.examDetail = null;
          this.title = '';
          this.description = '';
          this.time = false;
          this.repeat = 0;
          this.answer = 1;
          // this.active = false;
          this.randomQuestion = false;
          this.mins = 0;
          this.secs = 0;
          this.questions = [];
          this.questionsList = [];
          // this.$refs.form.reset();
          this.tagLevel = '';
          this.setNumberOfQuestion = 0;
          this.setScoreOfQuestion = 0;
          this.page = 1;
          this.setPercent = false;
          this.typeOfExam = false;
          this.randomChoices = false;
          this.percentExam = 0;
          this.arrTagLevel = [];
          this.chooseRandomQuestion = false;
        }
      }
    },
    // decrement() {
    //   if (this.rating == 1) {
    //     this.rating = 1;
    //     this.setScoreOfQuestion = this.rating;
    //   } else {
    //     this.rating--;
    //     this.setScoreOfQuestion = this.rating;
    //   }
    // },
    // increment() {
    //   if (this.rating == 10) {
    //     this.rating = 10;
    //     this.setScoreOfQuestion = this.rating;
    //   } else {
    //     this.rating++;
    //     this.setScoreOfQuestion = this.rating;
    //   }
    // },
    // decrementEdit(level) {
    //   if (level.text == 1) {
    //     level.text = 1;
    //     let index = this.arrTagLevel.indexOf(level);
    //     this.arrTagLevel[index].text = level.text;
    //   } else {
    //     level.text--;
    //   }
    // },
    // incrementEdit(level) {
    //   if (level.text == 10) {
    //     level.text = 10;
    //     let index = this.arrTagLevel.indexOf(level);
    //     this.arrTagLevel[index].text = level.text;
    //   } else {
    //     level.text++;
    //   }
    // },
    checkMinPercentExam() {
      if (this.percentExam < 0) this.percentExam = 0;
      if (this.percentExam > 100) this.percentExam = 100;
    },
    async tryExam(){
      this.loadingTryExam = true
      let numStamp= `${this.$store.state._id}${Date.now()}`
      // let service = `${this.$store.state.api}/startStateAdmin?idexam=${this.examId}&idcourse=${this.courseId}&idlecture=${this.lectureId}&numStamp=${numStamp}`;
      let param = {
        idexam: this.examId,
        idcourse: this.courseId,
        idlecture: this.lectureId,
        numStamp: numStamp
      }
      let result = await startStateAdmin(param)

      if(!result.statusCode) {
        this.previewTicket = result.result.ticket
        this.dialogPreviewTicket = true
        // let resultTicketDetail = await getAdminTicketDetail({ticketId: this.previewTicket, page: 1,limit: 5})
        // this.ticketId = resultTicketDetail
        this.dialog_review = true
        // console.log(resultTicketDetail)
      }
      this.loadingTryExam = false
    },
    closeDialogReview(){
      this.dialog_review = false
      this.ticketId = null
    },
    closeExamManagementDialog() {
      this.warnningToSaveDialog = false;
    },
    async closeDialog() {
      this.gameOptions = {};
      this.dialog = false;
      // this.reload("close select exam dialog");
      this.closeExamDialog();
      await this.getQuestionList(this.examId);
      await this.getListTagLevel(this.examId);
      await this.getListTagLevelFilter(this.examId);
    },
    closeExamDialog() {
      this.dialog_singleChoice = false;
      this.dialog_multiChoice = false;
      this.dialog_matching = false;
      this.dialog_fillWord = false;
      this.dialog_examArticle = false;
      this.dialog_descriptive = false;
      this.dialog_gameMaker = false;
    },
    openTagLevel() {
      this.questionGroupDialog = true;
      this.itemTaglevel.isAdd = true;
      this.itemTaglevel.text = '';
      this.itemTaglevel.numberOfQuestion = 0;
      this.itemTaglevel.score = 0;
      this.itemTaglevel.id = '';
    },
    async setTagLevel() {
      if (this.itemTaglevel.isAdd && this.questionGroupDialog) {
        this.arrTagLevel.push({
          text: this.itemTaglevel.text,
          numberOfQuestion: parseFloat(this.itemTaglevel.numberOfQuestion),
          score: parseFloat(this.itemTaglevel.score),
          sumScore:
            this.itemTaglevel.numberOfQuestion * this.itemTaglevel.score,
          countQuestion: 0,
        });
        this.setScoreOfQuestion = 0;
        await this.totalSumScore();
      } else if (
        !this.itemTaglevel.isAdd &&
        this.itemTaglevel.index >= 0 &&
        this.itemTaglevel.index !== ''
      ) {
        let index = this.itemTaglevel.index;
        this.arrTagLevel[index].text = this.itemTaglevel.text;
        this.arrTagLevel[index].numberOfQuestion = parseFloat(
          this.itemTaglevel.numberOfQuestion
        );
        this.arrTagLevel[index].score = parseFloat(this.itemTaglevel.score);
        this.arrTagLevel[index].sumScore =
          this.itemTaglevel.score * this.itemTaglevel.numberOfQuestion;
        // this.arrTagLevel[index].id = item.id;
        // this.arrTagLevel[index].countQuestion = item.countQuestion;
        // this.arrTagLevel[index].boolean = true;
        await this.totalSumScore();
      }
      await console.log(this.arrTagLevel);
    },
    totalSumScore() {
      var total = 0;
      var sum = 0;
      this.arrTagLevelFilter.forEach((level) => {
        total += level.numberOfQuestion;
        sum += level.sumScore;
        this.totalQuestion = total;
        this.totalScore = sum;
      });
      this.totalScore = +this.totalScore.toFixed(4)
      this.tagLevel = '';
      this.setNumberOfQuestion = 0;
      this.setScoreOfQuestion = 0;
    },
    editTagLevel(item, index) {
      this.questionGroupDialog = true;
      this.itemTaglevel.index = index;
      this.itemTaglevel.isAdd = false;
      this.itemTaglevel.text = item.text;
      this.itemTaglevel.numberOfQuestion = item.numberOfQuestion;
      this.itemTaglevel.score = item.score;
      this.itemTaglevel.id = item.id;
    },
    canCelEditLevel(level) {
      let index = this.arrTagLevel.indexOf(level);
      if (level.id) {
        level.text = this.temp_text;
        level.numberOfQuestion = this.temp_numberOfQuestion;
        level.score = this.temp_score;
        level.sumScore = this.temp_sumScore;
        level.countQuestion = this.temp_countQuestion;
        level.boolean = false;
        this.editLevel = false;
        this.bools = false;
      } else {
        console.log('else dont have level.id');
        this.removeRow(level);
        this.bools = false;
      }
      this.questionGroupDialog = false;
    },
    removeRow: function (item) {
      let index = this.arrTagLevel.indexOf(item);

      if (this.arrTagLevel.length >= 1) {
        this.arrTagLevel.splice(index, 1);
        this.totalSumScore();
      }
    },
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$message({
        message: 'Please do not upload files larger than 1m in size.',
        type: 'warning',
      });
      return false;
    },
    handleSuccess({ results }, file) {
      this.excelFile = file;
      this.isExcelFile = true;
      // this.excelData = results;
      // this.showExampleTable = true;
      // this.previewImportStudent(results);
    },

    async importExcel(typeExam) {
      let i = 0
      this.excelpages = 1;
      try{
      // for (var i = 0; i < this.tableData.length; i++) {
      while(this.tableData.length>0) {
        
        this.importIndex = this.tableData[i].no
        let choice_1 = '';
        let choice_2 = '';
        let choice_3 = '';
        let choice_4 = '';
        let choice_5 = '';
        let choice_6 = '';
        let choice_7 = '';
        let choice_8 = '';
        let choice_9 = '';
        let choice_10 = '';
        let arrChoiceId = [];

        let choiceCorrect = [];
        let arrChoices = [];

        if (typeExam === 'single') {
          this.uploading = true;
          let isSingle = this.tableData[i].answer.toString().split(",").length >1 ? false : true
          if (isSingle) {
            if (this.tableData[i].choice_1 != null) {
              choice_1 = await insertChoice({
                text: this.tableData[i].choice_1,
              });
              if (choice_1.code && choice_1.code != 200) {
                throw "Insert Choice error";
              }
            }
            if (this.tableData[i].choice_2 != null) {
              choice_2 = await insertChoice({
                text: this.tableData[i].choice_2,
              });
              if (choice_2.code && choice_2.code != 200) {
                throw "Insert Choice error";
              }
            }
            if (this.tableData[i].choice_3 != null) {
              choice_3 = await insertChoice({
                text: this.tableData[i].choice_3,
              });
              if (choice_3.code && choice_3.code != 200) {
                throw "Insert Choice error";
              }
            }
            if (this.tableData[i].choice_4 != null) {
              choice_4 = await insertChoice({
                text: this.tableData[i].choice_4,
              });
              if (choice_4.code && choice_4.code != 200) {
                throw "Insert Choice error";
              }
            }
            if (this.tableData[i].choice_5 != null) {
              choice_5 = await insertChoice({
                text: this.tableData[i].choice_5,
              });
              if (choice_5.code && choice_5.code != 200) {
                throw "Insert Choice error";
              }
            }
            if (this.tableData[i].choice_6 != null) {
              choice_6 = await insertChoice({
                text: this.tableData[i].choice_6,
              });
              if (choice_6.code && choice_6.code != 200) {
                throw "Insert Choice error";
              }
            }
            if (this.tableData[i].choice_7 != null) {
              choice_7 = await insertChoice({
                text: this.tableData[i].choice_7,
              });
              if (choice_7.code && choice_7.code != 200) {
                throw "Insert Choice error";
              }
            }
            if (this.tableData[i].choice_8 != null) {
              choice_8 = await insertChoice({
                text: this.tableData[i].choice_8,
              });
              if (choice_8.code && choice_8.code != 200) {
                throw "Insert Choice error";
              }
            }
            if (this.tableData[i].choice_9 != null) {
              choice_9 = await insertChoice({
                text: this.tableData[i].choice_9,
              });
              if (choice_9.code && choice_9.code != 200) {
                throw "Insert Choice error";
              }
            }
            if (this.tableData[i].choice_10 != null) {
              choice_10 = await insertChoice({
                text: this.tableData[i].choice_10,
              });
              if (choice_10.code && choice_10.code != 200) {
                throw "Insert Choice error";
              }
            }
            if (choice_1 != null) {
              await arrChoiceId.push(choice_1._id);
            }
            if (choice_2 != null) {
              await arrChoiceId.push(choice_2._id);
            }
            if (choice_3 != null) {
              await arrChoiceId.push(choice_3._id);
            }
            if (choice_4 != null) {
              await arrChoiceId.push(choice_4._id);
            }
            if (choice_5 != null) {
              await arrChoiceId.push(choice_5._id);
            }
            if (choice_6 != null) {
              await arrChoiceId.push(choice_6._id);
            }
            if (choice_7 != null) {
              await arrChoiceId.push(choice_7._id);
            }
            if (choice_8 != null) {
              await arrChoiceId.push(choice_8._id);
            }
            if (choice_9 != null) {
              await arrChoiceId.push(choice_9._id);
            }
            if (choice_10 != null) {
              await arrChoiceId.push(choice_10._id);
            }
            if (arrChoiceId) {
              arrChoiceId.forEach((value, index) => {
                if (this.tableData[i].answer - 1 === index) {
                  choiceCorrect.push(value);
                }
              });
            }
            let tempScore = null;
            if (this.typeOfExam == true) {
              this.arrTagLevel.forEach((level) => {
                if (this.tableData[i].question_group_id == level.id) {
                  tempScore = level.score;
                }
              });
            }
            let question = {
              idexam: this.examId,
              typeQuestion: typeExam,
              question: this.tableData[i].question.toString(),
              choices: arrChoiceId,
              correct: choiceCorrect,
              note: this.tableData[i].answer_description,
              randomChoice: this.randomChoices,
              score:
                this.typeOfExam == true ? tempScore : this.tableData[i].score,
              video: null,
              audio: null,
              level:
                this.typeOfExam == true
                  ? this.tableData[i].question_group_id
                  : null,
            };
            let resultQuestion = await insertQuestion(question);
            if (resultQuestion.code && resultQuestion.code != 200) {
                throw "Insert Question error";
              }
            console.log(resultQuestion);
            this.page = 1;
            await this.getQuestionList(this.examId);
            await this.getListTagLevel(this.examId);
            await this.getListTagLevelFilter(this.examId);
          } else {
            this.dialoguploadWarning = true;
          }
        } else {
          this.uploading = true;
          if (this.tableData[i].choice_1 != null) {
            choice_1 = await insertChoice({
              text: this.tableData[i].choice_1,
            });
            if (choice_1.code && choice_1.code != 200) {
              throw "Insert Choice error";
            }
            
          }
          if (this.tableData[i].choice_2 != null) {
            choice_2 = await insertChoice({
              text: this.tableData[i].choice_2,
            });
            if (choice_2.code && choice_2.code != 200) {
              throw "Insert Choice error";
            }
          }
          if (this.tableData[i].choice_3 != null) {
            choice_3 = await insertChoice({
              text: this.tableData[i].choice_3,
            });
            if (choice_3.code && choice_3.code != 200) {
              throw "Insert Choice error";
            }
          }
          if (this.tableData[i].choice_4 != null) {
            choice_4 = await insertChoice({
              text: this.tableData[i].choice_4,
            });
            if (choice_4.code && choice_4.code != 200) {
              throw "Insert Choice error";
            }
          }
          if (this.tableData[i].choice_5 != null) {
            choice_5 = await insertChoice({
              text: this.tableData[i].choice_5,
            });
            if (choice_5.code && choice_5.code != 200) {
              throw "Insert Choice error";
            }
          }
          if (this.tableData[i].choice_6 != null) {
            choice_6 = await insertChoice({
              text: this.tableData[i].choice_6,
            });
            if (choice_6.code && choice_6.code != 200) {
              throw "Insert Choice error";
            }
          }
          if (this.tableData[i].choice_7 != null) {
            choice_7 = await insertChoice({
              text: this.tableData[i].choice_7,
            });
            if (choice_7.code && choice_7.code != 200) {
              throw "Insert Choice error";
            }
          }
          if (this.tableData[i].choice_8 != null) {
            choice_8 = await insertChoice({
              text: this.tableData[i].choice_8,
            });
            if (choice_8.code && choice_8.code != 200) {
              throw "Insert Choice error";
            }
          }
          if (this.tableData[i].choice_9 != null) {
            choice_9 = await insertChoice({
              text: this.tableData[i].choice_9,
            });
            if (choice_9.code && choice_9.code != 200) {
              throw "Insert Choice error";
            }
          }
          if (this.tableData[i].choice_10 != null) {
            choice_10 = await insertChoice({
              text: this.tableData[i].choice_10,
            });
            if (choice_10.code && choice_10.code != 200) {
              throw "Insert Choice error";
            }
          }
          if (choice_1 != null) {
            await arrChoiceId.push(choice_1._id);
          }
          if (choice_2 != null) {
            await arrChoiceId.push(choice_2._id);
          }
          if (choice_3 != null) {
            await arrChoiceId.push(choice_3._id);
          }
          if (choice_4 != null) {
            await arrChoiceId.push(choice_4._id);
          }
          if (choice_5 != null) {
            await arrChoiceId.push(choice_5._id);
          }
          if (choice_6 != null) {
            await arrChoiceId.push(choice_6._id);
          }
          if (choice_7 != null) {
            await arrChoiceId.push(choice_7._id);
          }
          if (choice_8 != null) {
            await arrChoiceId.push(choice_8._id);
          }
          if (choice_9 != null) {
            await arrChoiceId.push(choice_9._id);
          }
          if (choice_10 != null) {
            await arrChoiceId.push(choice_10._id);
          }
          if (this.tableData[i].answer.toString().includes(',')) {
            arrChoices = this.tableData[i].answer.toString().split(',');
            arrChoiceId.forEach((value, index) => {
              arrChoices.forEach((correct) => {
                if (correct.trim() - 1 === index) {
                  choiceCorrect.push(value);
                }
              });
            });
          } else {
            if (arrChoiceId) {
              arrChoiceId.forEach((value, index) => {
                if (this.tableData[i].answer - 1 === index) {
                  choiceCorrect.push(value);
                }
              });
            }
          }
          let tempScore = null;
          if (this.typeOfExam == true) {
            this.arrTagLevel.forEach((level) => {
              if (this.tableData[i].question_group_id == level.id) {
                tempScore = level.score;
              }
            });
          }
          let question = {
            idexam: this.examId,
            typeQuestion: typeExam,
            question: this.tableData[i].question.toString(),
            choices: arrChoiceId,
            correct: choiceCorrect,
            note: this.tableData[i].answer_description,
            randomChoice: this.randomChoices,
            score:
              this.typeOfExam == true ? tempScore : this.tableData[i].score,
            video: null,
            audio: null,
            level:
              this.typeOfExam == true
                ? this.tableData[i].question_group_id
                : null,
          };

          let resultQuestion = await insertQuestion(question);
          if (resultQuestion.code && resultQuestion.code != 200) {
              throw "Insert Question error";
            }
          console.log(resultQuestion);
          this.page = 1;
          await this.getQuestionList(this.examId);
          await this.getListTagLevel(this.examId);
          await this.getListTagLevelFilter(this.examId);
        }
        // this.showStatus[this.tableData[i].no-1] = false
        
        await this.setShowStatus(this.tableData[i].no-1, true)
        
        await this.tableData.splice(i, 1)
        await this.animationTimeout(2000)
          
        await this.paginationManual();
      }
      }
      catch(error){
        console.log(error)
        this.dialogImportFail = true
        return
      }
      this.uploading = false;
      this.dialogExcelSingle = false;
      this.dialogExcelMulti = false;
      this.dialogImportExam = false;
      this.tableData = [];
    },
    animationTimeout(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    setShowStatus(index,status){
      this.showStatus[index] = status
    },
    closeExcelDialog() {
      this.tableData = [];
      this.dialogExcelSingle = false;
      this.dialogExcelMulti = false;
      this.pageLevelImport = 1;
      this.pageLevelImportLength = 1;
    },
    closeImportFailDialog() {
      this.dialogImportFail = false
      // this.importIndex = 0
      this.uploading = false;
    },
    // startBuffer() {
    //   clearInterval(this.interval);

    //   this.interval = setInterval(() => {
    //     this.value += Math.random() * (15 - 5) + 5;
    //     this.bufferValue += Math.random() * (15 - 5) + 6;
    //   }, 2000);
    // },
    changePriority(item) {
      item.boolean = true;
    },
    cancelChangePriority(item) {
      item.boolean = false;
      item.priorityLocal = null;
    },
    async saveChangePriority(item) {
      item.boolean = false;
      this.priorityLocalTemp = item.priorityLocal;
      let data = {
        idquestion: item._id,
        priority: item.priorityLocal - 1,
        idexam: this.examId,
      };
      if (item.typeQuestion == 'article') {
        let arrArticle = [];
        item.children.forEach((arr) => {
          arrArticle.push(arr._id);
        });
        let dataArticle = {
          idquestion: item._id,
          priority: item.priorityLocal - 1,
          idexam: this.examId,
          arrArticle: arrArticle,
        };
        let result = await shiftquestion(dataArticle);
        if (result) {
          await this.getQuestionList(this.examId);
        }
      } else {
        let result = await shiftquestion(data);
        if (result) {
          await this.getQuestionList(this.examId);
        }
      }
    },
    chooseTypeAnswer(type) {
      this.choiceType = type;
    },
    editQuestion(questionId, typeQuestion, articleQuestionId) {
      this.questionId = questionId;
      this.questionType = typeQuestion;
      this.articleId = articleQuestionId;
      // this.dialog = true;
      switch (this.questionType) {
        case 'single':
          this.dialog_singleChoice = true;
          break;

        case 'multiple':
          this.dialog_multiChoice = true;
          break;

        case 'matchsome':
          this.dialog_matching = true;
          break;

        case 'fillgaptext':
          this.dialog_fillWord = true;
          break;

        case 'article':
          this.dialog_examArticle = true;
          break;
        case 'game':
          this.dialog_gameMaker = true;
          break;
        case 'crossword':
        case 'wordsearch':
        case 'memorygame':
          this.gameOptions = { type: typeQuestion };
          this.dialog_gameMaker = true;
          break;

        default:
          break;
      }
    },
    openDeleteQuestionDialog(questionID) {
      this.deleteQuestionID = questionID;
      this.deleteQuestionDialog = true;
    },
    closeDeleteQuestionDialog() {
      this.deleteQuestionID = '';
      this.deleteQuestionDialog = false;
    },
    closeLectureExamDialog() {
      this.resetInitForm();
      if (this.type == 'EXAM') {
        this.$router.push({
          path: '/course/detail',
          query: { id: this.$route.query.id, step: 1, tab: 'lecture' },
        });
      } else {
        this.closeLectureDialog();
      }

      this.warnningToSaveDialog = false;
    },
    checkFaceDetection() {
      if (this.faceDetectionRandom == true) {
        this.selectedNumberQuestion = [];
      } else if (this.faceDetectionRandom == false) {
        this.faceDetectionLimit = 0;
      } else {
        this.faceDetectionLimit = 0;
        this.selectedNumberQuestion = [];
      }
    },
    resetInitForm() {
      this.main_tabs = 'detail';
      this.title = '';
      this.description = '';
      this.time = false;
      this.repeat = 0;
      this.answer = 1;
      // this.active = false;
      this.isModifyStartEndTime = false;
      this.randomQuestion = false;

      // this.lectureId = "";
      this.newLectureID = '';
      this.examId = null;

      this.tagLevel = '';
      this.setNumberOfQuestion = 0;
      this.setScoreOfQuestion = 0;
      this.arrTagLevel = [];
      this.editLevel = false;
      this.temptext = '';
      this.bools = false;
      this.typeOfExam = false;
      this.totalQuestion = 0;
      this.totalScore = 0;
      this.conditionalRandom = false;
      this.settingLevel = false;
      // this.rating = 1;
      this.temp_text = '';
      this.delTagLevelId = '';
      this.page = 1;
      this.setPercent = false;
      this.percentExam = 0;
      this.randomChoices = false;

      this.warnningToSaveDialog = false;
      this.faceDetection = false;
      this.faceDetectionRandom = false;
      this.faceDetectionLimit = 0;
      this.selectedNumberQuestion = [];
      this.totalRandom = 0;
      this.$refs.form.resetValidation();
    },
    confirmDelete(questionId) {
      this.dialogDelete = true;
      this.delQuestionId = questionId;
    },
    deleteItemQuestion(questionID) {
      this.dialogDelete = false;
      this.dialogDeleteSuccess = true;
      this.deleteQuestion(questionID);
      this.closeDeleteQuestionDialog();
    },
    confirmDeleteTagLevel(id) {
      this.dialogDeleteTagLevel = true;
      this.delTagLevelId = id;
    },
    deleteTagLevel(idTagLevel) {
      this.dialogDeleteTagLevel = false;
      this.delTagLevel();
      this.dialogDeleteTagLevelSuccess = true;
    },
    async delTagLevel() {
      let result = await deleteTagLevel({
        examId: this.examId,
        idtaglevel: this.delTagLevelId,
        active: false,
      });
      await this.getListTagLevel(this.examId);
      await this.getQuestionList(this.examId);
      await this.getListTagLevelFilter(this.examId);
    },

    async deleteQuestion(questionId) {
      // let arrayQuestionId = [];

      // this.questions.map(question =>
      //   question.children.length > 0
      //     ? (arrayQuestionId.push(question._id),
      //       question.children.map(child => arrayQuestionId.push(child._id)))
      //     : arrayQuestionId.push(question._id)
      // );

      // let newArray = arrayQuestionId.filter(function(value) {
      //   return value != questionId;
      // });

      // await this.reorderQuestion(this.examId, newArray);
      let result = await deleteQuestion({
        idexam: this.examId,
        idquestion: questionId,
      });
      await this.getQuestionList(this.examId);
      await this.getListTagLevel(this.examId);
      await this.getListTagLevelFilter(this.examId);
    },
    async checkMoveQuestion() {
      let arrayQuestionId = [];

      this.questionsList.map((question) =>
        question.children.length > 0
          ? (arrayQuestionId.push(question._id),
            question.children.map((child) => arrayQuestionId.push(child._id)))
          : arrayQuestionId.push(question._id)
      );
      this.selected_exam = [];
      this.allSelected = false;
      await this.reorderQuestion(this.examId, arrayQuestionId);
      this.selected_exam = [];
      this.allSelected = false;
      await this.getQuestionList(this.examId);
    },
    async validate() {
      await this.setTagLevel();
      this.loadingbtn = true;
      this.warnningToSaveDialog = false;
      let selectNumberToString = [];

      await this.selectedNumberQuestion.forEach((numberChoice) => {
        if (numberChoice.value) {
          selectNumberToString.push(numberChoice.value);
        }
      });

      let faceDetectionChoiceString = await selectNumberToString.toString();
      if (this.$refs.form.validate()) {
        let timeMins = parseInt(this.mins) * 60;
        let timeSecs = parseInt(this.secs);
        let timeMilliSec = (timeMins + timeSecs) * 1000;
        let startTime = new Date(this.startTime).getTime();
        let endTime = new Date(this.endTime).getTime();

        // if (this.active === false) {
        //   this.isModifyStartEndTime = false;
        // }

        if (!this.newLectureID) {
          if (this.isModifyStartEndTime) {
            let exam = await insertExam({
              title: this.title,
              description: this.description,
              choiceFormat: this.choiceType,
              questions: [],
              countTime: this.time,
              timeUse: Math.abs(timeMilliSec),
              showAnswer: this.answer,
              // active: this.active,
              startTime: startTime,
              endTime: endTime,
              randomChoice: this.randomChoices,
              randomQuestion:
                this.typeOfExam == true ? true : this.randomQuestion,
              randomSetting:
                this.typeOfExam == true ? true : this.chooseRandomQuestion,
              chooseQuestion: this.setNumberClause,
              randomIsFirst: this.conditionalRandom,
              typeCheckExam: this.setPercent == true ? 'percentage' : '',
              checkPercent: this.percentExam,
              isReset: false, //รอทำจริงมีuiแล้ว, ปรึกษาหลายคน
              limited:
                this.repeat != 1 && this.repeat != 0
                  ? this.repeatTimes
                  : this.repeat,
              courses: this.$route.query.id,

              faceDetection: this.faceDetection,

              faceDetectionRandom:
                this.faceDetection == false ? null : this.faceDetectionRandom,
              faceDetectionChoice:
                this.faceDetection == false ? null : faceDetectionChoiceString,
              faceDetectionLimit:
                this.faceDetection == false || this.faceDetectionRandom == false
                  ? null
                  : this.faceDetectionLimit,
            });
            if (exam.code && exam.code != 200) {
              this.dialogSaveFail = true;
            } else {
              let result = await insertLecture({
                id: this.sectionId,
                title: this.title,
                description: this.description,
                exams: [exam._id],
                type: 'EXAM',
              });
              if (result.code && result.code != 200) {
                this.dialogSaveFail = true;
              }
              // this.arrTagLevel.forEach(async (level) => {
              for (let level of this.arrTagLevel) {
                let resultLevel = await insertTagLevel({
                  title: level.text,
                  exam: exam._id,
                  choose: level.numberOfQuestion,
                });
                console.log(resultLevel);
                if (resultLevel.message == 'title duplicate') {
                  this.dialogDuplicade = true; //กรณีชื่อซ้ำ
                }
                if (resultLevel.code && resultLevel.code != 200) {
                  this.dialogSaveFail = true;
                }
                // else if (status.code == 403) {
                //   this.dialogEditFail = true; //กรณี error อื่น
                // } else {
                //   this.dialogEditSuccess = true;
                //   this.clearForm();
                //   this.getUserList();
                // }
              }

              this.newLectureID = result._id;
              this.examId = exam._id;
              // await updateExamActive({ id: this.examId, active: this.active });
              this.resultLecture = result;
              this.loadingbtn = false;
              // await this.reload();
              await this.getCourseSectionDetail();
              await this.getExamDetail(this.examId);
              await this.getListTagLevel(this.examId);
              await this.getListTagLevelFilter(this.examId);
            }
          } else {
            if (this.time == true && Math.abs(timeMilliSec) == 0) {
              this.dialogFail = true;
            } else if (this.repeat == 5 && this.repeatTimes == 0) {
              this.dialogFail = true;
            } else {
              let exam = await insertExam({
                title: this.title,
                description: this.description,
                choiceFormat: this.choiceType,
                questions: [],
                countTime: this.time,
                timeUse: Math.abs(timeMilliSec),
                showAnswer: this.answer,
                // active: this.active,
                randomChoice: this.randomChoices,
                randomQuestion:
                  this.typeOfExam == true ? true : this.randomQuestion,
                randomSetting:
                  this.typeOfExam == true ? true : this.chooseRandomQuestion,
                chooseQuestion: this.setNumberClause,
                randomIsFirst: this.conditionalRandom,
                typeCheckExam: this.setPercent == true ? 'percentage' : '',
                checkPercent: this.percentExam,
                isReset: false, //รอทำจริงมีuiแล้ว, ปรึกษาหลายคน
                limited:
                  this.repeat != 1 && this.repeat != 0
                    ? this.repeatTimes
                    : this.repeat,
                courses: this.$route.query.id,

                faceDetection: this.faceDetection,

                faceDetectionRandom:
                  this.faceDetection == false ? null : this.faceDetectionRandom,
                faceDetectionChoice:
                  this.faceDetection == false
                    ? null
                    : faceDetectionChoiceString,
                faceDetectionLimit:
                  this.faceDetection == false ||
                  this.faceDetectionRandom == false
                    ? null
                    : this.faceDetectionLimit,
              });
              if (exam.code && exam.code != 200) {
                this.dialogSaveFail = true;
              } else {
                let result = await insertLecture({
                  id: this.sectionId,
                  title: this.title,
                  description: this.description,
                  exams: [exam._id],
                  type: 'EXAM',
                });
                if (result.code && result.code != 200) {
                  this.dialogSaveFail = true;
                }
                this.resultLecture = result;
                // this.arrTagLevel.forEach(async (level) => {
                for (let level of this.arrTagLevel) {
                  let resultLevel = await insertTagLevel({
                    title: level.text,
                    score: level.score,
                    exam: exam._id,
                    choose: level.numberOfQuestion,
                  });
                  console.log(resultLevel);
                  if (resultLevel.message == 'title duplicate') {
                    this.dialogDuplicade = true; //กรณีชื่อซ้ำ
                  }
                  if (resultLevel.code && resultLevel.code != 200) {
                    this.dialogSaveFail = true;
                  }
                }

                this.newLectureID = result._id;
                this.examId = exam._id;
                // await updateExamActive({ id: this.examId, active: this.active });
                this.loadingbtn = false;
                //await this.reload();
                await this.getCourseSectionDetail();
                // this.dialogSuccess = true;
                // await this.getExamDetail(this.examId);
                // await this.getListTagLevel(this.examId);
                // this.main_tabs = "question";
              }
            }
          }

          // this.snackbar2 = true;
        } else {
          let currentLecture = this.lectures.filter(
            (lecture) => lecture._id === this.newLectureID
          )[0];

          let arrayQuestionId = [];
          await this.questions.map((question) =>
            question.children.length > 0
              ? (arrayQuestionId.push(question._id),
                question.children.map((child) =>
                  arrayQuestionId.push(child._id)
                ))
              : arrayQuestionId.push(question._id)
          );

          if (this.isModifyStartEndTime) {
            let exam = await updateExam({
              ...this.examDetail,
              idexam: this.examId,
              courses: this.$route.query.id,
              title: this.title,
              description: this.description,
              choiceFormat: this.choiceType,
              countTime: this.time,
              showAnswer: this.answer,
              // active: this.active,
              startTime: new Date(this.startTime).getTime(),
              endTime: new Date(this.endTime).getTime(),
              randomChoice: this.randomChoices,
              randomQuestion:
                this.typeOfExam == true ? true : this.randomQuestion,
              randomSetting:
                this.typeOfExam == true ? true : this.chooseRandomQuestion,
              chooseQuestion: this.setNumberClause,
              randomIsFirst: this.conditionalRandom,
              typeCheckExam: this.setPercent == true ? 'percentage' : '',
              checkPercent: this.percentExam,
              isReset: false, //รอทำจริงมีuiแล้ว, ปรึกษาหลายคน
              questions: arrayQuestionId,
              timeUse: Math.abs(timeMilliSec),
              limited:
                this.repeat != 1 && this.repeat != 0
                  ? this.repeatTimes
                  : this.repeat,
              owner_by_students: this.examDetail.owner_by_students.map(
                (obj) => obj._id
              ),
              owner_by_tutors: this.examDetail.owner_by_tutors.map(
                (obj) => obj._id
              ),
              owner_by_staffs: this.examDetail.owner_by_staffs.map(
                (obj) => obj._id
              ),

              faceDetection: this.faceDetection,

              faceDetectionRandom:
                this.faceDetection == false ? null : this.faceDetectionRandom,
              faceDetectionChoice:
                this.faceDetection == false ? null : faceDetectionChoiceString,
              faceDetectionLimit:
                this.faceDetection == false || this.faceDetectionRandom == false
                  ? null
                  : this.faceDetectionLimit,
            });
            let resultRandomChoice = await updateExamRandomChoice({
              idexam: this.examId,
              randomChoice: this.randomChoices,
            });
            if (exam.code && exam.code != 200) {
              this.dialogSaveFail = true;
            } else {
              let result = await updateLecture({
                ...currentLecture,
                id: this.newLectureID,
                title: this.title,
                description: this.description,
                type: 'EXAM',
                exams: [this.examId],
              });
              if (result.code && result.code != 200) {
                this.dialogSaveFail = true;
              }
              // this.arrTagLevel.forEach(async (level) => {
              // to saveTagLevel
              // for (let level of this.arrTagLevel) {
              //   if (level.id) {
              //     let resultLevel = await updateTagLevel({
              //       idtaglevel: level.id,
              //       title: level.text,
              //       score: level.score,
              //       exam: this.examId,
              //       choose: level.numberOfQuestion,
              //     });
              //     console.log(resultLevel);
              //     if (resultLevel.message == 'title duplicate') {
              //       this.dialogDuplicade = true; //กรณีชื่อซ้ำ
              //     }
              //     if (resultLevel.code && resultLevel.code != 200) {
              //       this.dialogSaveFail = true;
              //     }
              //   } else {
              //     let resultLevel = await insertTagLevel({
              //       title: level.text,
              //       score: level.score,
              //       exam: exam._id,
              //       choose: level.numberOfQuestion,
              //     });
              //     console.log(resultLevel);
              //     if (resultLevel.message == 'title duplicate') {
              //       this.dialogDuplicade = true; //กรณีชื่อซ้ำ
              //     }
              //     if (resultLevel.code && resultLevel.code != 200) {
              //       this.dialogSaveFail = true;
              //     }
              //   }
              // }

              // if (exam) {
              //   this.dialogSuccess = true;
              //   // this.main_tabs = "question";
              // }
              //this.loadingbtn = false;
              // await this.reload();
              // await this.getCourseSectionDetail();
              // await this.getQuestionList(this.examId);
            }
          } else {
            if (this.time == true && Math.abs(timeMilliSec) == 0) {
              this.dialogFail = true;
            } else if (this.repeat == 5 && this.repeatTimes == 0) {
              this.dialogFail = true;
            } else {
              let exam = await updateExam({
                ...this.examDetail,
                idexam: this.examId,
                courses: this.$route.query.id,
                title: this.title,
                description: this.description,
                choiceFormat: this.choiceType,
                countTime: this.time,
                showAnswer: this.answer,
                // active: this.active,
                randomChoice: this.randomChoices,
                startTime: 0,
                endTime: 0,
                randomQuestion:
                  this.typeOfExam == true ? true : this.randomQuestion,
                randomSetting:
                  this.typeOfExam == true ? true : this.chooseRandomQuestion,
                chooseQuestion: this.setNumberClause,
                randomIsFirst: this.conditionalRandom,
                typeCheckExam: this.setPercent == true ? 'percentage' : '',
                checkPercent: this.percentExam,
                isReset: false, //รอทำจริงมีuiแล้ว, ปรึกษาหลายคน
                questions: arrayQuestionId,
                timeUse: Math.abs(timeMilliSec),
                limited:
                  this.repeat != 1 && this.repeat != 0
                    ? this.repeatTimes
                    : this.repeat,
                owner_by_students: this.examDetail.owner_by_students.map(
                  (obj) => obj._id
                ),
                owner_by_tutors: this.examDetail.owner_by_tutors.map(
                  (obj) => obj._id
                ),
                owner_by_staffs: this.examDetail.owner_by_staffs.map(
                  (obj) => obj._id
                ),

                faceDetection: this.faceDetection,

                faceDetectionRandom:
                  this.faceDetection == false ? null : this.faceDetectionRandom,
                faceDetectionChoice:
                  this.faceDetection == false
                    ? null
                    : faceDetectionChoiceString,
                faceDetectionLimit:
                  this.faceDetection == false ||
                  this.faceDetectionRandom == false
                    ? null
                    : this.faceDetectionLimit,
              });
              let resultRandomChoice = await updateExamRandomChoice({
                idexam: this.examId,
                randomChoice: this.randomChoices,
              });
              if (exam.code && exam.code != 200) {
                this.dialogSaveFail = true;
              } else {
                await updateLecture({
                  ...currentLecture,
                  id: this.newLectureID,
                  title: this.title,
                  description: this.description,
                  type: 'EXAM',
                  exams: [this.examId],
                });
                // this.arrTagLevel.forEach(async (level) => {
                //to saveTagLevel
                // for (let level of this.arrTagLevel) {
                //   if (level.id) {
                //     let resultLevel = await updateTagLevel({
                //       idtaglevel: level.id,
                //       title: level.text,
                //       score: level.score,
                //       exam: this.examId,
                //       choose: level.numberOfQuestion,
                //     });
                //     console.log(resultLevel);
                //     if (resultLevel.message == 'title duplicate') {
                //       this.dialogDuplicade = true; //กรณีชื่อซ้ำ
                //     }
                //     if (resultLevel.code && resultLevel.code != 200) {
                //       this.dialogSaveFail = true;
                //     }
                //   } else {
                //     let resultLevel = await insertTagLevel({
                //       title: level.text,
                //       score: level.score,
                //       exam: exam._id,
                //       choose: level.numberOfQuestion,
                //     });
                //     console.log(resultLevel);
                //     if (resultLevel.message == 'title duplicate') {
                //       this.dialogDuplicade = true; //กรณีชื่อซ้ำ
                //     }
                //     if (resultLevel.code && resultLevel.code != 200) {
                //       this.dialogSaveFail = true;
                //     }
                //   }
                // }

                // if (exam) {
                //   this.dialogSuccess = true;
                //   // this.main_tabs = "question";
                // }
                //dialog

                // this.snackbar2 = true;

                // await updateExamActive({ id: this.examId, active: this.active });
                // await this.reload(result);
              }
            }
            this.loadingbtn = false;
          }
        }
      }
      this.loadingbtn = false;
      // await this.reload();
      if (
        (this.isFirstEdit && !this.typeOfExam) ||
        (this.isFirstEdit && this.typeOfExam && this.arrTagLevel.length > 0)
      ) {
        this.main_tabs = 'question';
        this.isFirstEdit = false;
      }
      await this.getCourseSectionDetail();
      this.dialogSuccess = true;
      //this.questionGroupDialog = false;
      await this.getExamDetail(this.examId);
      //this.arrTagLevel = [];
      //await this.getListTagLevel(this.examId);
      //await this.updateListTagLevelForCheck();
      //await this.getQuestionList(this.examId);
    },
    openDialogImport(typeOpen) {
      this.typeImport = typeOpen;
      this.tableData = [];
      this.tableTempData = [];
      this.excelFile = '';
      this.isExcelFile = false;
      switch (typeOpen) {
        case 'single':
          this.dialogExcelSingle = true;
          break;
        case 'multiple':
          this.dialogExcelMulti = true;
          break;
      }
      
      this.getListTagLevelImport(this.examId);
    },
    async handlePreviewSuccessOld({ results }, file) {
      console.log(results)
      this.importIndex = 0
      this.previewExamFailDialog = false
      this.excelFile = file;
      this.isExcelFile = true;
      this.tableData = results;
      this.boolDisable = false;
      this.tableData.forEach((data, index) => {
        let setbool = 0;
        if (data.question_group_id) {
          for (let level of this.arrTagLevelForCheck) {
            if (data.question_group_id == level.id) {
              setbool += 1;
              let obj = {
                text: level.text,
                score: level.score,
                ...this.tableData[index],
              };
              this.tableData[index] = obj;
            }
          }
          if (setbool == 0) {
            let obj = {
              wrong: true,
              ...this.tableData[index],
            };
            this.tableData[index] = obj;
            this.boolDisable = true;
          }
        } else if (this.typeOfExam == false) {
          this.boolDisable = false;
        } else {
          this.boolDisable = true;
        }
      });
      console.log(this.tableData, this.boolDisable);
      this.canImport = false;
      // this.tableData.forEach((exam) => {
        for(let [index,exam] of this.tableData.entries()){
        if (this.typeImport == 'single') {
          if (
            exam.answer.toString().length == 1 &&
            exam.answer.toString() > 0 &&
            exam.answer.toString() <= 10 && exam.score !== null && exam.score !== undefined
          ) {
            if (exam.answer.toString() == 1 && exam.choice_1 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 2 && exam.choice_2 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 3 && exam.choice_3 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 4 && exam.choice_4 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 5 && exam.choice_5 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 6 && exam.choice_6 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 7 && exam.choice_7 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 8 && exam.choice_8 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 9 && exam.choice_9 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 10 && exam.choice_10 != null) {
              this.canImport = true;
            }
          } else {
            this.canImport = false;
            this.tableData = []
            this.previewExamFailDialog = true
            return
          }
        }
        if (this.typeImport == 'multiple') {
          if (
            exam.answer.toString().length == 1 &&
            exam.answer.toString() > 0 &&
            exam.answer.toString() <= 10 && exam.score !== null && exam.score !== undefined
          ) {
            if (exam.answer.toString() == 1 && exam.choice_1 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 2 && exam.choice_2 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 3 && exam.choice_3 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 4 && exam.choice_4 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 5 && exam.choice_5 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 6 && exam.choice_6 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 7 && exam.choice_7 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 8 && exam.choice_8 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 9 && exam.choice_9 != null) {
              this.canImport = true;
            }
            if (exam.answer.toString() == 10 && exam.choice_10 != null) {
              this.canImport = true;
            }
          } else {
            this.canImport = false;
            this.tableData = []
            this.previewExamFailDialog = true
            return
          }
          if (exam.answer.toString().includes(',')) {
            let arrChoices = exam.answer.toString().split(',');
            console.log(arrChoices);
            this.canImport = false;
            // arrChoices.forEach((correct) => {
            for(let correct of arrChoices){
              // add condition
              if (correct == 1 && exam.choice_1 == null) {
                this.cantPreviewImport()
                console.log('correct == 1');
              } else if (correct == 2 && exam.choice_2 == null) {
                this.cantPreviewImport()
                console.log('correct == 2');
              } else if (correct == 3 && exam.choice_3 == null) {
                this.cantPreviewImport()
                console.log('correct == 3');
              } else if (correct == 4 && exam.choice_4 == null) {
                this.cantPreviewImport()
                console.log('correct == 4');
              } else if (correct == 5 && exam.choice_5 == null) {
                this.cantPreviewImport()
                console.log('correct == 5');
              } else if (correct == 6 && exam.choice_6 == null) {
                this.cantPreviewImport()
                console.log('correct == 6');
              } else if (correct == 7 && exam.choice_7 == null) {
                this.cantPreviewImport()
                console.log('correct == 7');
              } else if (correct == 8 && exam.choice_8 == null) {
                this.cantPreviewImport()
                console.log('correct == 8');
              } else if (correct == 9 && exam.choice_9 == null) {
                this.cantPreviewImport()
                console.log('correct == 9');
              } else if (correct == 10 && exam.choice_10 == null) {
                this.cantPreviewImport()
                console.log('correct == 10');
              } else {
                this.canImport = true;
              }
            // });
            }
          }
        }
      // });
        }
      this.showStatus = new Array(this.tableData.length).fill(false)
      this.showExampleTable = true;
      this.excelpages = 1;
      this.paginationManual();
    },
    async checkHasAnswerInChoice(exam){
      let answer = exam.answer.toString()
      if(exam[`choice_${answer}`] != null && exam[`choice_${answer}`].toString().trim() !== ""){
          return true
      }
      return false
    },
    async checkHasAnswerInChoiceForMulti(answer,exam){
      if(exam[`choice_${answer}`] != null && exam[`choice_${answer}`].toString().trim() !== ""){
        return true
      }
      return false
    },
    async handlePreviewSuccess({ results }, file) {
      console.log(results)
      this.importIndex = 0
      this.previewExamFailDialog = false
      this.excelFile = file;
      this.isExcelFile = true;
      this.tableData = results;
      this.boolDisable = false;
      // this.tableData.forEach((data, index) => {
        for(let [index,data] of this.tableData.entries()){
        let setbool = 0;
        if (data.question_group_id) {
          for (let level of this.arrTagLevelForCheck) {
            if (data.question_group_id == level.id) {
              setbool += 1;
              let obj = {
                text: level.text,
                score: level.score,
                ...this.tableData[index],
              };
              this.tableData[index] = obj;
            }
          }
          if (setbool == 0) {
            let obj = {
              wrong: true,
              ...this.tableData[index],
            };
            this.tableData[index] = obj;
            this.boolDisable = true;
          }
        } else if (this.typeOfExam == false) {
          this.boolDisable = false;
        } else {
          this.boolDisable = true;
        }
      }
      this.canImport = false;
      let errorAtQuestion = []
      if(this.typeImport == 'single'){
        for(let [index,exam] of this.tableData.entries()){
          if(exam.question == undefined|| exam.question.toString().trim() == ""){ //check answer field
            errorAtQuestion.push(index+1)
          } else if(exam.answer == undefined){ //check answer field
            errorAtQuestion.push(index+1)
          } else if(exam.answer.toString().length < 1){ //check answer field
            errorAtQuestion.push(index+1)
          } else if(exam.answer.toString() <= 0 && exam.answer.toString() > 10){ //check total answer
            errorAtQuestion.push(index+1)
          } else if(exam.score == null || exam.score == undefined || typeof exam.score == "string"){ //check score
            errorAtQuestion.push(index+1)
          } else {
            let hasChoice = await this.checkHasAnswerInChoice(exam) 
            if(!hasChoice){
              errorAtQuestion.push(index+1)
            }
          }
        }
        
      } else if (this.typeImport == 'multiple') {
          for(let [index,exam] of this.tableData.entries()){
            if(exam.question == undefined|| exam.question.toString().trim() == ""){ //check answer field
              errorAtQuestion.push(index+1)
            } else if(exam.answer == undefined){ //check answer field
              errorAtQuestion.push(index+1)
            } else if(exam.score == null || exam.score == undefined || typeof exam.score == "string"){ //check score
              errorAtQuestion.push(index+1)
            } else if(exam.answer.toString().length < 1){ //check answer field
              errorAtQuestion.push(index+1)
            }else if(exam.answer.toString().length == 1){
              if(exam.answer.toString() <= 0 && exam.answer.toString() > 10){ //check total answer
                errorAtQuestion.push(index+1)
              } else{
                let hasChoice = await this.checkHasAnswerInChoice(exam) 
                if(!hasChoice){
                  errorAtQuestion.push(index+1)
                }
              }
            }else if(exam.answer.toString().length > 1){
              let arrChoices = exam.answer.toString().split(',');
              this.canImport = false;
              for(let correct of arrChoices){
                let hasChoice = await this.checkHasAnswerInChoiceForMulti(correct,exam)
                if(!hasChoice){
                  errorAtQuestion.push(index+1)
                  break;
                }
              }
            }
        }
      }
      if(errorAtQuestion.length > 0){
          this.canImport = false;
          this.tableData = []
          this.importErrorAtQuestion = errorAtQuestion.join(', ')
          this.previewExamFailDialog = true
          return
        }
      this.canImport = true
      this.showStatus = new Array(this.tableData.length).fill(false)
      this.showExampleTable = true;
      this.excelpages = 1;
      this.paginationManual();
    },
    cantPreviewImport(){
      this.canImport = false;
      this.tableData = []
      this.previewExamFailDialog = true
      return
    },
    paginationManual() {
      this.tableTempData = [];
      let idx = this.excelpages * this.perPage - this.perPage;
      let total = this.perPage * this.excelpages;
      for (let index = idx; index < total; index++) {
        if (index < this.tableData.length) {
          this.tableTempData.push(this.tableData[index]);
        }
      }
    },
    async openDialogImportSingle() {
      this.dialogExcelSingle = true;
      await this.getListTagLevelImport(this.examId);
    },
    async openDialogImportMulti() {
      this.dialogExcelMulti = true;
      await this.getListTagLevelImport(this.examId);
    },
    async changePageLevel(page) {
      this.pageLevel = page;
      await this.getListTagLevel(this.examId);
    },
    async changePageLevelImport(page) {
      this.pageLevelImport = page;
      await this.getListTagLevelImport(this.examId);
    },
    copyToClipBoard(item) {
      navigator.clipboard.writeText(item.id);
      this.snackbar = true;
    },
    async getListTagLevelForCheck(examId) {
      let params = {
        idexam: examId,
        sort: 'created_at',
        sortby: 1,
        page: 1,
        limit: 100,
      };
      this.arrTagLevelForCheck = [];
      let result = await getListTagLevel(params);
      console.log(result.data);

      result.data.forEach((level) => {
        this.arrTagLevelForCheck.push({
          id: level._id,
          text: level.title,
          score: level.score,
          sumScore: level.score * level.choose,
          numberOfQuestion: level.choose,
          countQuestion: level.countQuestion,
          boolean: false,
        });
      });
      this.totalSumScore();
      console.log(this.arrTagLevelForCheck);
    },
    async getListTagLevel(examId) {
      this.loading = true;
      // this.totalRandom = 0;
      let params = {
        idexam: examId,
        sort: 'created_at',
        sortby: 1,
        page:
          this.dialogExcelSingle == true || this.dialogExcelMulti == true
            ? this.pageLevelImport
            : this.pageLevel,
        limit: 5,
      };
      this.arrTagLevel = [];
      // this.arrTagLevelFilter = [];
      let result = await getListTagLevel(params);
      // console.log(result.data);
      this.dialogExcelSingle == true || this.dialogExcelMulti == true
        ? (this.pageLevelImportLength = result.maxPage)
        : (this.pageLevelLength = result.maxPage);
      if (result.data.length != 0) {
        this.settingLevel = true;
        this.typeOfExam = true;
        // result.data.forEach((level) => {
        // this.arrTagLevelFilter.push({
        //   id: null,
        //   text: 'แสดงทั้งหมด',
        //   score: null,
        //   sumScore: null,
        //   numberOfQuestion: null,
        //   countQuestion: null,
        //   boolean: false,
        // });
        for (let level of result.data) {
          // this.totalRandom += level.choose;
          this.arrTagLevel.push({
            id: level._id,
            text: level.title,
            score: level.score,
            sumScore: +(level.score * level.choose).toFixed(2),
            numberOfQuestion: level.choose,
            countQuestion: level.countQuestion,
            boolean: false,
          });
          // this.arrTagLevelFilter.push({
          //   id: level._id,
          //   text: level.title,
          //   score: level.score,
          //   sumScore: level.score * level.choose,
          //   numberOfQuestion: level.choose,
          //   countQuestion: level.countQuestion,
          //   boolean: false,
          // });
        }
        // this.totalSumScore();
        this.loading = false;
      } else {
        this.settingLevel = false;
      }
    },
    async getListTagLevelImport(examId) {
      this.loadingImport = true;
      // this.totalRandom = 0;
      let params = {
        idexam: examId,
        sort: 'created_at',
        sortby: 1,
        page: this.pageLevelImport,
        limit: 5,
      };
      this.arrTagLevelImport = [];
      // this.arrTagLevelFilter = [];
      let result = await getListTagLevel(params);
      // console.log(result.data);
      this.pageLevelImportLength = result.maxPage
      if (result.data.length != 0) {
        for (let level of result.data) {
          // this.totalRandom += level.choose;
          this.arrTagLevelImport.push({
            id: level._id,
            text: level.title,
            score: level.score,
            sumScore: level.score * level.choose,
            numberOfQuestion: level.choose,
            countQuestion: level.countQuestion,
            boolean: false,
          });
        }
        // this.totalSumScore();
        this.loadingImport = false
      } else {
        this.settingLevel = false;
      }
    },

    async getListTagLevelFilter(examId) {
      this.loading = true;
      this.totalRandom = 0;
      let params = {
        idexam: examId,
        sort: 'created_at',
        sortby: 1,
        page: 1,
        limit: 1000,
      };
      // this.arrTagLevel = [];
      this.arrTagLevelFilter = [];
      let result = await getListTagLevel(params);
      // this.dialogExcelSingle == true || this.dialogExcelMulti == true
      //   ? (this.pageLevelImportLength = result.maxPage)
      //   : (this.pageLevelLength = result.maxPage);
      if (result.data.length != 0) {
        this.settingLevel = true;
        this.typeOfExam = true;
        // result.data.forEach((level) => {
        this.arrTagLevelFilter.push({
          id: null,
          text: 'แสดงทั้งหมด',
          score: null,
          sumScore: null,
          numberOfQuestion: null,
          countQuestion: null,
          boolean: false,
        });
        for (let level of result.data) {
          this.totalRandom += level.choose;
          // this.arrTagLevel.push({
          //   id: level._id,
          //   text: level.title,
          //   score: level.score,
          //   sumScore: level.score * level.choose,
          //   numberOfQuestion: level.choose,
          //   countQuestion: level.countQuestion,
          //   boolean: false,
          // });
          this.arrTagLevelFilter.push({
            id: level._id,
            text: level.title,
            score: level.score,
            sumScore: level.score * level.choose,
            numberOfQuestion: level.choose,
            countQuestion: level.countQuestion,
            boolean: false,
          });
        }
        this.totalSumScore();
        this.loading = false;
      } else {
        this.settingLevel = false;
      }
    },

    async getExamDetail(examId) {
      let params = {
        idexam: examId,
      };

      this.examDetail = await getExamById(params);

      this.title = this.examDetail.title;
      this.description = this.examDetail.description;
      this.time = this.examDetail.countTime;
      let timeMilliSec = this.examDetail.timeUse;
      this.mins = parseInt(timeMilliSec / 1000.0 / 60.0);
      this.choiceType = this.examDetail.choiceFormat;
      this.secs = (timeMilliSec / 1000.0) % 60.0;
      if (this.examDetail.limited === 1) {
        this.repeat = 1;
      } else if (this.examDetail.limited === 0) {
        this.repeat = 0;
      } else {
        this.repeat = 5;
      }
      this.repeatTimes = this.examDetail.limited;
      this.answer = this.examDetail.showAnswer;
      // this.active = this.examDetail.active;
      this.randomQuestion = this.examDetail.randomQuestion;
      this.typeOfExam = this.examDetail.randomSetting;
      this.randomChoices = this.examDetail.randomChoice;
      this.setPercent = this.examDetail.typeCheckExam ? true : false;
      this.percentExam = this.examDetail.checkPercent;
      this.chooseRandomQuestion = this.examDetail.randomSetting;
      this.setNumberClause = this.examDetail.chooseQuestion;
      this.conditionalRandom = this.examDetail.randomIsFirst;
      this.resetTicket = this.examDetail.isReset;
      this.startTime = new Date(this.examDetail.startTime).toISOString();
      this.startTimeOld = new Date(this.examDetail.startTime).toISOString();
      this.endTime = new Date(this.examDetail.endTime).toISOString();

      this.faceDetection = this.examDetail.faceDetection
        ? this.examDetail.faceDetection
        : false;
      this.faceDetectionRandom = this.examDetail.faceDetectionSetting
        ? this.examDetail.faceDetectionSetting.faceDetectionRandom
        : false;

      let numberChoice =
        this.examDetail.faceDetection == true
          ? this.examDetail.faceDetectionSetting.faceDetectionChoice
          : null;
      if (numberChoice) {
        let arrNumberChoice = numberChoice.split(',');
        this.selectedNumberQuestion = [];
        arrNumberChoice.forEach((number) => {
          this.selectedNumberQuestion.push({
            number: 'ข้อที่ ' + number,
            value: +number,
          });
        });
      } else {
        this.selectedNumberQuestion = [];
      }

      this.faceDetectionLimit = this.examDetail.faceDetectionSetting
        ? this.examDetail.faceDetectionSetting.faceDetectionLimit
        : 0;
      let oneDayMilli = 86400000;
      let currentDate = new Date();
      let initStartDateMilli = new Date(currentDate.getTime()).toISOString();
      let initEndDateMilli = new Date(
        currentDate.getTime() + oneDayMilli
      ).toISOString();

      if (this.examDetail.startTime == 0 || this.examDetail.startTime == null) {
        this.startTime = initStartDateMilli;
      } else {
        this.startTime = new Date(this.examDetail.startTime).toISOString();
      }

      if (this.examDetail.endTime == 0 || this.examDetail.endTime == null) {
        this.endTime = initEndDateMilli;
      } else {
        this.endTime = new Date(this.examDetail.endTime).toISOString();
      }

      if (this.examDetail.startTime > 0 || this.examDetail.endTime > 0) {
        this.isModifyStartEndTime = true;
      } else {
        this.isModifyStartEndTime = false;
      }
    },
    async changePage(page) {
      this.page = page;
      await this.getQuestionList(this.examId);
    },
    async modifyExam() {
      this.dialogModify = true;
      let result = await getQuestionListSwap({ idexam: this.examId });
      this.questionsList = [];
      result.forEach((question) => {
        switch (question.typeQuestion) {
          case 'single':
            question.icon = 'mdi-check-box-outline';
            question.name = 'ตัวเลือกเดียว';
            break;
          case 'multiple':
            question.icon = 'mdi-check-box-multiple-outline';
            question.name = 'หลายตัวเลือก';
            break;

          case 'matchsome':
          case 'matchall':
            question.icon = 'mdi-shuffle';
            question.name = 'จับคู่';
            break;

          case 'fillgapchoice':
          case 'fillgaptext':
            question.icon = 'mdi-color-helper';
            question.name = 'เติมคำ';
            break;

          case 'writing':
            question.icon = 'mdi-pencil';
            break;

          case 'article':
            question.icon = 'mdi-format-float-left';
            question.name = 'บทความ';
            break;

          case 'descriptive':
            question.icon = 'notes';
            question.name = 'คำบรรยาย';
            break;

          case 'memorygame':
            question.icon = 'mdi-puzzle';
            question.name = 'เกมความจำ (Memory Game)';
            break;
          case 'crossword':
            question.icon = 'mdi-puzzle';
            question.name = 'เกมไขว้คำ (Crossword)';
            break;
          case 'wordsearch':
            question.icon = 'mdi-puzzle';
            question.name = 'เกมหาคำ (Word Search)';
            break;

          default:
            question.icon = 'mdi-alphabetical-variant';
            break;
        }
        question.children = [];
      });
      this.questionsList = result.filter(
        (question) => !question.articleQuestion
      );
      result.forEach((question) => {
        if (question.articleQuestion) {
          this.questionsList.forEach((question2) => {
            if (question.articleQuestion == question2._id) {
              question2.children.push({
                ...question,
              });
            }
          });
        }
      });
    },
    async getListQuestionByTagLevel(idTagLevel) {
      console.log(idTagLevel);
      this.page = 1
      await this.getQuestionList(this.examId);
    },
    checkLimit() {
      if (this.faceDetectionLimit > this.countNumberQuestion) {
        this.faceDetectionLimit = this.countNumberQuestion;
      }
    },
    async getQuestionList(examId) {
      let result = [];
      this.countNumberQuestion = 0;
      this.listCountQuestion = [];
      if (this.typeOfExam == true) {
        let params = {
          idexam: examId,
          page: this.page,
          limit: this.limit,
          level: this.selectTagLevel,
        };
        result = await getQuestionList(params);
        this.countNumberQuestion = this.totalRandom;
        for (let i = 1; i <= this.countNumberQuestion; i++) {
          this.listCountQuestion.push({
            number: 'ข้อที่ ' + i,
            value: i,
          });
        }
      } else {
        let params = {
          idexam: examId,
          page: this.page,
          limit: this.limit,
        };
        result = await getQuestionList(params);

        this.countNumberQuestion = result.count;
        for (let i = 1; i <= this.countNumberQuestion; i++) {
          this.listCountQuestion.push({
            number: 'ข้อที่ ' + i,
            value: i,
          });
        }
      }

      this.questions = [];

      this.pageCount = result.maxPage;
      let number = 0;
      result.data.forEach((question) => {
        switch (question.typeQuestion) {
          case 'single':
            question.icon = 'mdi-check-box-outline';
            question.name = 'ตัวเลือกเดียว';
            number += 1;
            break;
          case 'multiple':
            question.icon = 'mdi-check-box-multiple-outline';
            question.name = 'หลายตัวเลือก';
            number += 1;
            break;

          case 'matchsome':
          case 'matchall':
            question.icon = 'mdi-shuffle';
            question.name = 'จับคู่';
            number += 1;
            break;

          case 'fillgapchoice':
          case 'fillgaptext':
            question.icon = 'mdi-color-helper';
            question.name = 'เติมคำ';
            number += 1;
            break;

          case 'writing':
            question.icon = 'mdi-pencil';
            number += 1;
            break;

          case 'article':
            question.icon = 'mdi-format-float-left';
            question.name = 'บทความ';
            this.countArticle += 1;
            break;

          case 'descriptive':
            question.icon = 'notes';
            question.name = 'คำบรรยาย';
            number += 1;
            break;

          case 'memorygame':
            question.icon = 'mdi-puzzle';
            question.name = 'เกมความจำ';
            break;
          case 'crossword':
            question.icon = 'mdi-puzzle';
            question.name = 'เกมไขว้คำ';
            break;
          case 'wordsearch':
            question.icon = 'mdi-puzzle';
            question.name = 'เกมหาคำ';
            break;

          default:
            question.icon = 'mdi-alphabetical-variant';
            break;
        }
        question.children = [];
        question.iconClass = 'grey lighten-1 black--text';
        question.priorityLocal = null;
        question.boolean = false;
        question.number = number;
      });

      this.questions = result.data.filter(
        (question) => !question.articleQuestion
      );
      await this.checkQuestionList(examId);
      this.selected_exam = [];
      this.allSelected = false;
    },
    async checkQuestionList(examId) {
      let number = 0;
      let tempQuestions = [];

      this.questions.forEach(async (q) => {
        if (q.level) {
          this.arrTagLevelFilter.forEach(async (tag) => {
            if (q.level === tag.id) {
              tempQuestions.push({
                ...q,
                tag: tag.text,
              });
            }
          });
          this.questions = tempQuestions;
        }
        if (q.typeQuestion == 'article') {
          let result = await getQuestionArticleById({
            idexam: examId,
            idarticle: q._id,
          });
          result.forEach((question) => {
            switch (question.typeQuestion) {
              case 'single':
                question.icon = 'mdi-check-box-outline';
                question.name = 'ตัวเลือกเดียว';
                number += 1;
                break;
              case 'multiple':
                question.icon = 'mdi-check-box-multiple-outline';
                question.name = 'หลายตัวเลือก';
                number += 1;
                break;

              case 'matchsome':
              case 'matchall':
                question.icon = 'mdi-shuffle';
                question.name = 'จับคู่';
                number += 1;
                break;

              case 'fillgapchoice':
              case 'fillgaptext':
                question.icon = 'mdi-color-helper';
                question.name = 'เติมคำ';
                number += 1;
                break;

              case 'writing':
                question.icon = 'mdi-pencil';
                number += 1;
                break;

              case 'article':
                question.icon = 'mdi-format-float-left';
                question.name = 'บทความ';
                this.countArticle += 1;
                break;

              case 'descriptive':
                question.icon = 'notes';
                question.name = 'คำบรรยาย';
                number += 1;
                break;

              case 'memorygame':
                question.icon = 'mdi-puzzle';
                question.name = 'เกมความจำ (Memory Game)';
                break;
              case 'crossword':
                question.icon = 'mdi-puzzle';
                question.name = 'เกมไขว้คำ (Crossword)';
                break;
              case 'wordsearch':
                question.icon = 'mdi-puzzle';
                question.name = 'เกมหาคำ (Word Search)';
                break;

              default:
                question.icon = 'mdi-alphabetical-variant';
                break;
            }
            question.children = [];
            question.iconClass = 'grey lighten-1 black--text';
            question.priorityLocalChild = null;
            question.boolean = false;
            question.number = number;
            if (question.articleQuestion) {
              if (question.articleQuestion == q._id) {
                q.children.push(question);
              }
            }
          });
        }
      });
    },
    openExpand(id, type) {
      let panel = $('#expand-' + id);
      let btn = $('#centerx-ele-' + id);
      if (type == 'list') {
        panel = $('#expand-list-' + id);
        btn = $('#centerx-ele-list-' + id);
      }
      btn.attr('disabled', true);
      if (panel.hasClass('active')) {
        panel.slideUp('slow');
        panel.removeClass('active');
        btn.removeClass('active');
        setTimeout(() => {
          btn.attr('disabled', false);
        }, 1000);
      } else {
        panel.slideDown('slow');
        panel.addClass('active');
        btn.addClass('active');
        setTimeout(() => {
          btn.attr('disabled', false);
        }, 1000);
      }
    },
    async reorderQuestion(examId, questions) {
      await reorderQuestion({
        idexam: examId,
        questions: questions,
      });

      await this.getExamDetail(examId);
      await this.getListTagLevel(this.examId);
      await this.getQuestionList(examId);
    },
    async closeDialogExam() {
      this.dialog = false;
      await this.getQuestionList(this.examId);
    },
    async closeDialogModify() {
      this.dialogModify = false;
      await this.getQuestionList(this.examId);
    },

    checkMinMins() {
      if (this.mins < 0) this.mins = 0;
    },
    checkMinSecs() {
      if (this.secs < 0) this.secs = 0;
      if (this.secs > 60) this.secs = 60;
    },
    // select to multi delete exam
    select: function () {
      this.allSelected = false;
    },
    // cancelSelect() {
    //   this.select();
    //   this.selected_exam = [];
    // },
    selectAll: function () {
      this.selected_exam = [];

      if (this.allSelected) {
        for (let i in this.questions) {
          this.selected_exam.push(this.questions[i]._id.toString());
        }
      }
    },
    confirmMultiDelete() {
      this.dialogMultiDelete = true;
    },
    async deleteMultiQuestion() {
      let arrayquestion = [];
      for (let i in this.selected_exam) {
        this.loadingDelete = true;
        arrayquestion.push({
          id: this.selected_exam[i],
        });
      }
      // this.questionListSelected.forEach((item) => {
      //   this.loadingDelete = true;
      //   arrayquestion.push({
      //     id: item._id,
      //   });
      // });
      let result = await deleteQuestionAll({
        idexam: this.examId,
        arrayquestion,
      });
      console.log(result);
      this.loadingDelete = false;
      this.dialogMultiDelete = false;
      this.dialogMultiDeleteSuccess = true;

      this.questionListSelected = [];
      this.selected_exam = [];
      this.page = 1;
      this.pageCount - 1;
      await this.getQuestionList(this.examId);
      await this.getListTagLevel(this.examId);
    },
    closeNoQuestionDialog() {
      this.noQuestionDialog = false;
    },
    checkQuestionMoreThanOne() {
      if (this.active == false) {
        if (this.questions.length <= 0) {
          // console.log(this.active)
          // this.active = false;
          // console.log(this.active)
          this.noQuestionDialog = true;
        }
        // else {
        //   this.active = true;
        // }
      }
    },
    async checkToSave() {
      if (this.lectureId) {
        this.arrArticle = 0;

        let timeMins = parseInt(this.mins) * 60;
        let timeSecs = parseInt(this.secs);
        let timeMilliSec = (timeMins + timeSecs) * 1000;
        let startTime = new Date(this.startTime).getTime();
        let endTime = new Date(this.endTime).getTime();

        let data = {
          ...this.examDetail,
          title: this.title,
          description: this.description,
          choiceFormat: this.choiceType,
          countTime: this.time,
          showAnswer: this.answer,
          startTime: this.isModifyStartEndTime ? startTime : 0,
          endTime: this.isModifyStartEndTime ? endTime : 0,
          // randomQuestion: this.randomQuestion,
          timeUse: Math.abs(timeMilliSec),
          limited:
            this.repeat != 1 && this.repeat != 0
              ? this.repeatTimes
              : this.repeat,
          conditionalRandom: false,
          settingLevel: false,
          setPercent: false,
          percentExam: 0,
          randomChoice: this.randomChoices,
          randomQuestion: this.typeOfExam == true ? true : this.randomQuestion,
          randomSetting:
            this.typeOfExam == true ? true : this.chooseRandomQuestion,
          chooseQuestion: this.setNumberClause,
          randomIsFirst: this.conditionalRandom,
          typeCheckExam: this.setPercent == true ? 'percentage' : '',
          checkPercent: this.percentExam,
        };

        // console.log(JSON.stringify(this.examDetail));
        // console.log(JSON.stringify(data));

        JSON.stringify(this.examDetail) !== JSON.stringify(data)
          ? (this.warnningToSaveDialog = true)
          : this.closeLectureExamDialog();
        // this.reload();
        await this.getCourseSectionDetail();
      } else {
        // this.reload();
        await this.getCourseSectionDetail();

        let timeMins = parseInt(this.mins) * 60;
        let timeSecs = parseInt(this.secs);
        let timeMilliSec = (timeMins + timeSecs) * 1000;
        let startTime = new Date(this.startTime).getTime();
        let endTime = new Date(this.endTime).getTime();

        let data = {
          title: this.title ? this.title : '',
          description: this.description ? this.description : '',
          choiceFormat: this.choiceType,
          countTime: this.time,
          showAnswer: this.answer,
          startTime: this.isModifyStartEndTime ? startTime : 0,
          endTime: this.isModifyStartEndTime ? endTime : 0,
          randomQuestion: this.randomQuestion,
          timeUse: Math.abs(timeMilliSec),
          limited:
            this.repeat != 1 && this.repeat != 0
              ? this.repeatTimes
              : this.repeat,
        };

        let target = {
          title: '',
          description: '',
          choiceFormat: 'number',
          countTime: false,
          showAnswer: 1,
          startTime: 0,
          endTime: 0,
          randomQuestion: false,
          timeUse: 0,
          limited: 0,
          tagLevel: '',
          arrTagLevel: [],
        };

        JSON.stringify(data) !== JSON.stringify(target)
          ? this.examId
            ? this.closeLectureExamDialog()
            : (this.warnningToSaveDialog = true)
          : this.closeLectureExamDialog();
      }
    },
    async getCourseSectionDetail() {
      let result = await getCourseById({
        id: this.courseId,
      });
      // filter section
      let data_section = result.sections.filter((item) => {
        return item._id == this.sectionId;
      });
      let data_lecture = [];
      data_section.forEach((section) => {
        let lectures = [];
        section.lectures.forEach((lecture) => {
          let lectureType = {};
          switch (lecture.type) {
            case 'VDO':
              lectureType = {
                icon: 'mdi-video-outline',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.video'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'YOUTUBE':
              lectureType = {
                icon: 'mdi-youtube',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.youtube'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'PDF':
              lectureType = {
                icon: 'mdi-file-document-outline',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.document'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'IMG':
              lectureType = {
                icon: 'mdi-image-outline',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.photo'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'EXAM':
              lectureType = {
                icon: 'mdi-format-annotation-plus',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.examination'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'FILE':
              lectureType = {
                icon: 'mdi-paperclip',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.otherFiles'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'BOOK':
              lectureType = {
                icon: 'mdi-book-open-page-variant',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.book'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'URL':
              lectureType = {
                icon: 'mdi-link-variant',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.website'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'BLOG':
              lectureType = {
                icon: 'mdi-format-float-left',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.article'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            default:
              lectureType = {
                icon: 'mdi-format-float-left',
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;
          }
          lectures.push(lectureType);
        });
        data_lecture = lectures;
      });
      this.lectures = data_lecture;
    },
    open_calender(event, which) {
      this.$refs[which].open(event);
    },
    async updateListTagLevelForCheck() {
      this.arrTagLevelForCheck = [];
      this.arrTagLevelForCheck = this.arrTagLevel;
    },
    async saveTagLevel() {
      this.loadingSaveTagLevel = true;
      if (this.itemTaglevel.isAdd) {
        let resultLevel = await insertTagLevel({
          title: this.itemTaglevel.text,
          score: this.itemTaglevel.score,
          exam: this.examId,
          choose: this.itemTaglevel.numberOfQuestion,
        });
        if (resultLevel.message == 'title duplicate') {
          this.dialogDuplicade = true; //กรณีชื่อซ้ำ
        }
        if (resultLevel.code && resultLevel.code != 200) {
          this.dialogSaveFail = true;
        } else {
          this.dialogSuccess = true;
        }
      } else {
        let resultLevel = await updateTagLevel({
          idtaglevel: this.itemTaglevel.id,
          title: this.itemTaglevel.text,
          score: this.itemTaglevel.score,
          exam: this.examId,
          choose: this.itemTaglevel.numberOfQuestion,
        });
        if (resultLevel.message == 'title duplicate') {
          this.dialogDuplicade = true; //กรณีชื่อซ้ำ
        }
        if (resultLevel.code && resultLevel.code != 200) {
          this.dialogSaveFail = true;
        } else {
          this.dialogSuccess = true;
        }
      }
      this.loadingSaveTagLevel = false;
      this.questionGroupDialog = false;
      this.arrTagLevel = [];
      await this.getListTagLevel(this.examId);
      await this.updateListTagLevelForCheck();
      await this.getListTagLevelFilter(this.examId);
      await this.getQuestionList(this.examId);
    },
  },
  async mounted() {
    this.lectureId = this.$route.query.lectureId;
    this.sectionId = this.$route.query.sectionId;
    this.courseId = this.$route.query.id;
    this.type = this.$route.query.type;
    this.isFirstEdit =
      Object.keys(this.$route.params).length > 0
        ? this.$route.params.firstEdit
        : false;
    await this.getCourseSectionDetail();
    await this.initialize(true);
    // this.startBuffer();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  beforeMount() {
    if (window.screen.width < 600) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 600 && window.screen.width < 960) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 960 && window.screen.width < 1264) {
      this.maxWidth = '40%';
    } else if (window.screen.width > 1264 && window.screen.width < 1904) {
      this.maxWidth = '40%';
    } else {
      this.maxWidth = '40%';
    }
  },
};
</script>

<style scoped>
.row.mt-3 .v-window {
  width: 100%;
}
.bg-card {
  /* background: #fafafa !important; */
}
.center {
  justify-content: center;
}
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}

.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.fix-width {
  max-width: 80px;
}
/* .set-date-exam {
  width: 80%;
} */
.datetime {
  padding: 10px;
  box-shadow: 0 0 0px 0 rgba(0, 0, 0, 0.19) !important;
  border: 1px solid #e0e0e0;
  border-radius: 5px !important;
  text-align: center;
  height: 45px;
  transition: box-shadow 0.3s ease-in-out;
}

.lecture-type-card {
  width: 100%;
  padding-bottom: 40%;
  padding-top: 40%;

  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.lecture-type-card:hover {
  transform: scale(1.15, 1.15);
  cursor: pointer;
}
.page-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.lecture-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.lesson-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 0px 0px 15px 15px;
  transition: transform 0.3s ease-in-out;
}

.text-right {
  text-align: right;
}

.input-number {
  height: 45px !important;
}

.input-number > .v-input__control > .v-input__slot {
  min-height: 45px !important;
}

.input {
  height: 45px !important;
}

.input > .v-input__control > .v-input__slot {
  min-height: 45px !important;
}

.input-number
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  > input {
  text-align: right;
}

.dialogStyle {
  height: 1000px;
}

.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}

.buttonTypeContent.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  width: 100%;
  padding-bottom: 50%;
  /* 1:1 Aspect Ratio */
  padding-top: 50%;
  /* border-radius: 50px; */
}

.textInbutton.v-btn__content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
}

.colCenter {
  text-align: center;
}

.textField {
  width: 100%;
}

.labelAttach.v-label.theme--light {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 30px;
}

p {
  margin: 0 0 5px;
}

.examplePDF {
  /* height: 450px; */
  text-align: center;
}

.iframePDF {
  width: 200px;
  height: 300px;
  /* overflow: hidden; */
}

.iframeWeb {
  width: 100%;
  height: auto;
  /* overflow: hidden; */
}

.explainFile {
  width: 100%;
  min-height: 150px;
  height: auto;
  margin-top: 7%;
}

.v-card__text.dialogStyle {
  height: 1000px;
  width: 70%;
  margin: 0 auto;
}

.manageButton {
  justify-content: flex-end;
}

.textAreaDetail {
  border-radius: 15px;
}

.divExplanFile {
  justify-content: flex-end;
}

.headExplan {
  color: red;
  font-size: 20px;
  font-weight: bold;
}

.labelExplan {
  text-align: justify;
}

.text-primary {
  color: rgb(66, 154, 216) !important;
}

.editor .ql-container {
  min-height: 150px;
}

@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
}

.article-order {
  background-color: #eeeeee;
}

.article-order-child {
  background-color: #f5f5f5;
}

/* @media only screen and (max-width: 600px ){
  .col {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}
} */
</style>
<style scoped>
.card-custom {
  border-radius: 4px 4px 0 0 !important;
  /* border: 1px solid #e0e0e0 !important; */
  border-bottom: 0 !important;
  background: #eeeeee !important;
}
.card-child {
  border-radius: 0 0 4px 4px !important;
  /* border: 1px solid #e0e0e0 !important; */
  border-top: 0 !important;
}
</style>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.border {
  border: 1px solid rgb(195, 195, 195) !important;
}
.position-relative {
  position: relative;
}
.colon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.v-tabs--grow > .v-tabs-bar .v-tab {
  flex: none;
}
.v-tab--active {
  background: #fff !important;
  color: #009bde;
}

.uppercast-unset {
  text-transform: unset;
}
.tab-exam {
  border-radius: 5px 5px 0 0;
  background: rgba(0, 0, 0, 0.04);
  border: 1px solid #e7e7e7;
  border-bottom: 0;
  box-shadow: 0;
  width: 200px;
}

.bg-exam {
  background-color: white;
}

.tab-head {
  border-bottom: 1px solid #e7e7e7;
}

.v-input--selection-controls {
  width: 100%;
}

.divider-data-table {
  min-height: 35%;
  max-height: 0%;
  margin-left: 2px;
  margin-right: 6px;
}

.container-import-exam {
  background-color: #f1f1f1d9;
}

.v-list-item__subtitle {
  margin: 5px;
  padding-top: 5px;
}

.v-list-item__subtitle span.choise {
  color: #4a90e2;
}

.text-icon-grey {
  color: #757575c2;
}

.md-position-relative {
  position: relative !important;
}

.md-position-absolute {
  position: absolute;
}

.centerx-ele {
  left: 50%;
  transform: translate(-50%, 0);
  top: 0;
}

.centerx-ele.active .icon {
  transform: rotate(180deg);
}

.card-no-data {
  border-style: dashed;
  border-width: 1.5px;
  border-color: grey;
}

.set-date-exam-start .exam-date {
  width: 70%;
  cursor: pointer;
}

.set-date-exam-end {
  width: 83%;
}

@media only screen and (min-width: 1800px) {
  .set-date-exam-end {
    width: 90%;
  }
}

.set-date-exam-end .exam-date {
  width: 65%;
  cursor: pointer;
}

#detail .v-input--selection-controls {
  margin-top: 0px;
}

#detail .row-radio-exam {
  padding-top: 0px;
  padding-bottom: 0px;
}
.icon-calendar {
  cursor: pointer;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .2s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
